import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
};

export type Access_Requests = {
  __typename?: 'access_requests';
  created_at: Scalars['Any'];
  id: Scalars['Any'];
  key: Scalars['Any'];
  metadata?: Maybe<Scalars['Any']>;
  recipient: Profiles;
  recipient_id: Scalars['Any'];
  requester: Profiles;
  requester_id: Scalars['Any'];
  resource_type: Scalars['Any'];
  space: Spaces;
  space_id: Scalars['Any'];
};


export type Access_RequestsMetadataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};

export type Access_Requests_Aggregate = {
  __typename?: 'access_requests_aggregate';
  aggregate?: Maybe<Access_Requests_Aggregate_Fields>;
  nodes: Array<Access_Requests>;
};

export type Access_Requests_Aggregate_Fields = {
  __typename?: 'access_requests_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Access_Requests_Max_Fields>;
  min?: Maybe<Access_Requests_Min_Fields>;
};


export type Access_Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Access_Requests_Max_Fields = {
  __typename?: 'access_requests_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  key?: Maybe<Scalars['Any']>;
  recipient_id?: Maybe<Scalars['Any']>;
  requester_id?: Maybe<Scalars['Any']>;
  resource_type?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Access_Requests_Min_Fields = {
  __typename?: 'access_requests_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  key?: Maybe<Scalars['Any']>;
  recipient_id?: Maybe<Scalars['Any']>;
  requester_id?: Maybe<Scalars['Any']>;
  resource_type?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Access_Requests_Mutation_Response = {
  __typename?: 'access_requests_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Access_Requests>;
};

export type Apps = {
  __typename?: 'apps';
  id: Scalars['Any'];
  name: Scalars['Any'];
  title: Scalars['Any'];
};

export type Apps_Aggregate = {
  __typename?: 'apps_aggregate';
  aggregate?: Maybe<Apps_Aggregate_Fields>;
  nodes: Array<Apps>;
};

export type Apps_Aggregate_Fields = {
  __typename?: 'apps_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Apps_Max_Fields>;
  min?: Maybe<Apps_Min_Fields>;
};


export type Apps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Apps_Max_Fields = {
  __typename?: 'apps_max_fields';
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  title?: Maybe<Scalars['Any']>;
};

export type Apps_Min_Fields = {
  __typename?: 'apps_min_fields';
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  title?: Maybe<Scalars['Any']>;
};

export type Apps_Mutation_Response = {
  __typename?: 'apps_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Apps>;
};

export type Chat_List = {
  __typename?: 'chat_list';
  cover_photo?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  display_name?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  latest_event?: Maybe<Scalars['Any']>;
  latest_resource?: Maybe<Scalars['Any']>;
  members: Array<Space_Members>;
  members_aggregate: Space_Members_Aggregate;
  name?: Maybe<Scalars['Any']>;
  resource?: Maybe<Resources>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  sender?: Maybe<Scalars['Any']>;
  unread_counts: Array<Unread_Counts>;
  unread_counts_aggregate: Unread_Counts_Aggregate;
  user_ids?: Maybe<Scalars['Any']>;
};


export type Chat_ListCover_PhotoArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListLatest_EventArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListLatest_ResourceArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListMembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListUnread_CountsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Chat_ListUnread_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Chat_List_Aggregate = {
  __typename?: 'chat_list_aggregate';
  aggregate?: Maybe<Chat_List_Aggregate_Fields>;
  nodes: Array<Chat_List>;
};

export type Chat_List_Aggregate_Fields = {
  __typename?: 'chat_list_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Chat_List_Max_Fields>;
  min?: Maybe<Chat_List_Min_Fields>;
};


export type Chat_List_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Chat_List_Max_Fields = {
  __typename?: 'chat_list_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  sender?: Maybe<Scalars['Any']>;
};

export type Chat_List_Min_Fields = {
  __typename?: 'chat_list_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  sender?: Maybe<Scalars['Any']>;
};

export type Claim_Private = {
  __typename?: 'claim_private';
  claim_id?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Claim_Private_Aggregate = {
  __typename?: 'claim_private_aggregate';
  aggregate?: Maybe<Claim_Private_Aggregate_Fields>;
  nodes: Array<Claim_Private>;
};

export type Claim_Private_Aggregate_Fields = {
  __typename?: 'claim_private_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Claim_Private_Max_Fields>;
  min?: Maybe<Claim_Private_Min_Fields>;
};


export type Claim_Private_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Claim_Private_Max_Fields = {
  __typename?: 'claim_private_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Claim_Private_Min_Fields = {
  __typename?: 'claim_private_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Claim_Private_Mutation_Response = {
  __typename?: 'claim_private_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Claim_Private>;
};

export type Claims = {
  __typename?: 'claims';
  created_at?: Maybe<Scalars['Any']>;
  id: Scalars['Any'];
  invitations: Array<Invitations>;
  invitations_aggregate: Invitations_Aggregate;
  is_claimed?: Maybe<Scalars['Any']>;
  is_invited: Scalars['Any'];
  private_info?: Maybe<Claim_Private>;
  profile?: Maybe<Profiles>;
  space_members: Array<Space_Members>;
  space_members_aggregate: Space_Members_Aggregate;
  type?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};


export type ClaimsInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ClaimsInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ClaimsSpace_MembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ClaimsSpace_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Claims_Aggregate = {
  __typename?: 'claims_aggregate';
  aggregate?: Maybe<Claims_Aggregate_Fields>;
  nodes: Array<Claims>;
};

export type Claims_Aggregate_Fields = {
  __typename?: 'claims_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Claims_Max_Fields>;
  min?: Maybe<Claims_Min_Fields>;
};


export type Claims_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Claims_Max_Fields = {
  __typename?: 'claims_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};

export type Claims_Min_Fields = {
  __typename?: 'claims_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};

export type Claims_Mutation_Response = {
  __typename?: 'claims_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Claims>;
};

export type Collection_Permissions = {
  __typename?: 'collection_permissions';
  collection: Resource_Collections;
  collection_id: Scalars['Any'];
  created_at: Scalars['Any'];
  space: Spaces;
  space_id: Scalars['Any'];
};

export type Collection_Permissions_Aggregate = {
  __typename?: 'collection_permissions_aggregate';
  aggregate?: Maybe<Collection_Permissions_Aggregate_Fields>;
  nodes: Array<Collection_Permissions>;
};

export type Collection_Permissions_Aggregate_Fields = {
  __typename?: 'collection_permissions_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Collection_Permissions_Max_Fields>;
  min?: Maybe<Collection_Permissions_Min_Fields>;
};


export type Collection_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Collection_Permissions_Max_Fields = {
  __typename?: 'collection_permissions_max_fields';
  collection_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Collection_Permissions_Min_Fields = {
  __typename?: 'collection_permissions_min_fields';
  collection_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Collection_Permissions_Mutation_Response = {
  __typename?: 'collection_permissions_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Collection_Permissions>;
};

export type Events = {
  __typename?: 'events';
  collection_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  data: Scalars['Any'];
  localId?: Maybe<Scalars['Any']>;
  order: Scalars['Any'];
  profile?: Maybe<Profiles>;
  resource?: Maybe<Resources>;
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
  resource_permissions: Array<Resource_Permissions>;
  resource_permissions_aggregate: Resource_Permissions_Aggregate;
  sender_key: Scalars['Any'];
  space: Spaces;
  space_app_id?: Maybe<Scalars['Any']>;
  space_id: Scalars['Any'];
  space_session: Scalars['Any'];
  type?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  user_key?: Maybe<Scalars['Any']>;
};


export type EventsDataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type EventsResource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type EventsResource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
  stddev?: Maybe<Events_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Sum_Fields>;
  var_pop?: Maybe<Events_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Var_Samp_Fields>;
  variance?: Maybe<Events_Variance_Fields>;
};


export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  collection_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  localId?: Maybe<Scalars['Any']>;
  order?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  sender_key?: Maybe<Scalars['Any']>;
  space_app_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  user_key?: Maybe<Scalars['Any']>;
};

export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  collection_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  localId?: Maybe<Scalars['Any']>;
  order?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  sender_key?: Maybe<Scalars['Any']>;
  space_app_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
  user_key?: Maybe<Scalars['Any']>;
};

export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Events>;
};

export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields';
  order?: Maybe<Scalars['Any']>;
  space_session?: Maybe<Scalars['Any']>;
};

export type Invitation_Replication = {
  __typename?: 'invitation_replication';
  claim?: Maybe<Claims>;
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  deleted?: Maybe<Scalars['Any']>;
  external_metadata?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitee?: Maybe<Profiles>;
  inviter?: Maybe<Profiles>;
  inviter_id?: Maybe<Scalars['Any']>;
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};


export type Invitation_ReplicationExternal_MetadataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};

export type Invitation_Replication_Aggregate = {
  __typename?: 'invitation_replication_aggregate';
  aggregate?: Maybe<Invitation_Replication_Aggregate_Fields>;
  nodes: Array<Invitation_Replication>;
};

export type Invitation_Replication_Aggregate_Fields = {
  __typename?: 'invitation_replication_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Invitation_Replication_Max_Fields>;
  min?: Maybe<Invitation_Replication_Min_Fields>;
};


export type Invitation_Replication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Invitation_Replication_Max_Fields = {
  __typename?: 'invitation_replication_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitation_Replication_Min_Fields = {
  __typename?: 'invitation_replication_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitations = {
  __typename?: 'invitations';
  claim?: Maybe<Claims>;
  claim_id?: Maybe<Scalars['Any']>;
  created_at: Scalars['Any'];
  external_metadata?: Maybe<Scalars['Any']>;
  id: Scalars['Any'];
  invitee?: Maybe<Profiles>;
  inviter?: Maybe<Profiles>;
  inviter_id?: Maybe<Scalars['Any']>;
  space: Spaces;
  space_id: Scalars['Any'];
  status?: Maybe<Scalars['Any']>;
  updated_at: Scalars['Any'];
  user_id?: Maybe<Scalars['Any']>;
};


export type InvitationsExternal_MetadataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};

export type Invitations_Aggregate = {
  __typename?: 'invitations_aggregate';
  aggregate?: Maybe<Invitations_Aggregate_Fields>;
  nodes: Array<Invitations>;
};

export type Invitations_Aggregate_Fields = {
  __typename?: 'invitations_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Invitations_Max_Fields>;
  min?: Maybe<Invitations_Min_Fields>;
};


export type Invitations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Invitations_Deleted = {
  __typename?: 'invitations_deleted';
  claim_id?: Maybe<Scalars['Any']>;
  created_at: Scalars['Any'];
  external_metadata?: Maybe<Scalars['Any']>;
  id: Scalars['Any'];
  inviter_id?: Maybe<Scalars['Any']>;
  space_id: Scalars['Any'];
  status?: Maybe<Scalars['Any']>;
  updated_at: Scalars['Any'];
  user_id?: Maybe<Scalars['Any']>;
};


export type Invitations_DeletedExternal_MetadataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};

export type Invitations_Deleted_Aggregate = {
  __typename?: 'invitations_deleted_aggregate';
  aggregate?: Maybe<Invitations_Deleted_Aggregate_Fields>;
  nodes: Array<Invitations_Deleted>;
};

export type Invitations_Deleted_Aggregate_Fields = {
  __typename?: 'invitations_deleted_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Invitations_Deleted_Max_Fields>;
  min?: Maybe<Invitations_Deleted_Min_Fields>;
};


export type Invitations_Deleted_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Invitations_Deleted_Max_Fields = {
  __typename?: 'invitations_deleted_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitations_Deleted_Min_Fields = {
  __typename?: 'invitations_deleted_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitations_Deleted_Mutation_Response = {
  __typename?: 'invitations_deleted_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Invitations_Deleted>;
};

export type Invitations_Max_Fields = {
  __typename?: 'invitations_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitations_Min_Fields = {
  __typename?: 'invitations_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  inviter_id?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  status?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Invitations_Mutation_Response = {
  __typename?: 'invitations_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Invitations>;
};

export type Mutation_Root = {
  __typename?: 'mutation_root';
  delete_access_requests?: Maybe<Access_Requests_Mutation_Response>;
  delete_access_requests_by_pk?: Maybe<Access_Requests>;
  delete_apps?: Maybe<Apps_Mutation_Response>;
  delete_apps_by_pk?: Maybe<Apps>;
  delete_claim_private?: Maybe<Claim_Private_Mutation_Response>;
  delete_claims?: Maybe<Claims_Mutation_Response>;
  delete_claims_by_pk?: Maybe<Claims>;
  delete_collection_permissions?: Maybe<Collection_Permissions_Mutation_Response>;
  delete_collection_permissions_by_pk?: Maybe<Collection_Permissions>;
  delete_events?: Maybe<Events_Mutation_Response>;
  delete_events_by_pk?: Maybe<Events>;
  delete_invitations?: Maybe<Invitations_Mutation_Response>;
  delete_invitations_by_pk?: Maybe<Invitations>;
  delete_invitations_deleted?: Maybe<Invitations_Deleted_Mutation_Response>;
  delete_profiles?: Maybe<Profiles_Mutation_Response>;
  delete_profiles_by_pk?: Maybe<Profiles>;
  delete_read_receipts?: Maybe<Read_Receipts_Mutation_Response>;
  delete_read_receipts_by_pk?: Maybe<Read_Receipts>;
  delete_resource_collection_links?: Maybe<Resource_Collection_Links_Mutation_Response>;
  delete_resource_collection_links_by_pk?: Maybe<Resource_Collection_Links>;
  delete_resource_collections?: Maybe<Resource_Collections_Mutation_Response>;
  delete_resource_collections_by_pk?: Maybe<Resource_Collections>;
  delete_resource_permissions?: Maybe<Resource_Permissions_Mutation_Response>;
  delete_resource_permissions_by_pk?: Maybe<Resource_Permissions>;
  delete_resources?: Maybe<Resources_Mutation_Response>;
  delete_resources_by_pk?: Maybe<Resources>;
  delete_space_apps?: Maybe<Space_Apps_Mutation_Response>;
  delete_space_apps_by_pk?: Maybe<Space_Apps>;
  delete_space_members?: Maybe<Space_Members_Mutation_Response>;
  delete_space_members_by_pk?: Maybe<Space_Members>;
  delete_space_members_deleted?: Maybe<Space_Members_Deleted_Mutation_Response>;
  delete_spaces?: Maybe<Spaces_Mutation_Response>;
  delete_spaces_by_pk?: Maybe<Spaces>;
  delete_user_devices?: Maybe<User_Devices_Mutation_Response>;
  delete_user_devices_by_pk?: Maybe<User_Devices>;
  insert_access_requests?: Maybe<Access_Requests_Mutation_Response>;
  insert_access_requests_one?: Maybe<Access_Requests>;
  insert_apps?: Maybe<Apps_Mutation_Response>;
  insert_apps_one?: Maybe<Apps>;
  insert_claim_private?: Maybe<Claim_Private_Mutation_Response>;
  insert_claim_private_one?: Maybe<Claim_Private>;
  insert_claims?: Maybe<Claims_Mutation_Response>;
  insert_claims_one?: Maybe<Claims>;
  insert_collection_permissions?: Maybe<Collection_Permissions_Mutation_Response>;
  insert_collection_permissions_one?: Maybe<Collection_Permissions>;
  insert_events?: Maybe<Events_Mutation_Response>;
  insert_events_one?: Maybe<Events>;
  insert_invitations?: Maybe<Invitations_Mutation_Response>;
  insert_invitations_deleted?: Maybe<Invitations_Deleted_Mutation_Response>;
  insert_invitations_deleted_one?: Maybe<Invitations_Deleted>;
  insert_invitations_one?: Maybe<Invitations>;
  insert_profiles?: Maybe<Profiles_Mutation_Response>;
  insert_profiles_one?: Maybe<Profiles>;
  insert_read_receipts?: Maybe<Read_Receipts_Mutation_Response>;
  insert_read_receipts_one?: Maybe<Read_Receipts>;
  insert_resource_collection_links?: Maybe<Resource_Collection_Links_Mutation_Response>;
  insert_resource_collection_links_one?: Maybe<Resource_Collection_Links>;
  insert_resource_collections?: Maybe<Resource_Collections_Mutation_Response>;
  insert_resource_collections_one?: Maybe<Resource_Collections>;
  insert_resource_permissions?: Maybe<Resource_Permissions_Mutation_Response>;
  insert_resource_permissions_one?: Maybe<Resource_Permissions>;
  insert_resources?: Maybe<Resources_Mutation_Response>;
  insert_resources_one?: Maybe<Resources>;
  insert_space_apps?: Maybe<Space_Apps_Mutation_Response>;
  insert_space_apps_one?: Maybe<Space_Apps>;
  insert_space_members?: Maybe<Space_Members_Mutation_Response>;
  insert_space_members_deleted?: Maybe<Space_Members_Deleted_Mutation_Response>;
  insert_space_members_deleted_one?: Maybe<Space_Members_Deleted>;
  insert_space_members_one?: Maybe<Space_Members>;
  insert_spaces?: Maybe<Spaces_Mutation_Response>;
  insert_spaces_one?: Maybe<Spaces>;
  insert_user_devices?: Maybe<User_Devices_Mutation_Response>;
  insert_user_devices_one?: Maybe<User_Devices>;
  update_access_requests?: Maybe<Access_Requests_Mutation_Response>;
  update_access_requests_by_pk?: Maybe<Access_Requests>;
  update_access_requests_many?: Maybe<Array<Maybe<Access_Requests_Mutation_Response>>>;
  update_apps?: Maybe<Apps_Mutation_Response>;
  update_apps_by_pk?: Maybe<Apps>;
  update_apps_many?: Maybe<Array<Maybe<Apps_Mutation_Response>>>;
  update_claim_private?: Maybe<Claim_Private_Mutation_Response>;
  update_claim_private_many?: Maybe<Array<Maybe<Claim_Private_Mutation_Response>>>;
  update_claims?: Maybe<Claims_Mutation_Response>;
  update_claims_by_pk?: Maybe<Claims>;
  update_claims_many?: Maybe<Array<Maybe<Claims_Mutation_Response>>>;
  update_collection_permissions?: Maybe<Collection_Permissions_Mutation_Response>;
  update_collection_permissions_by_pk?: Maybe<Collection_Permissions>;
  update_collection_permissions_many?: Maybe<Array<Maybe<Collection_Permissions_Mutation_Response>>>;
  update_events?: Maybe<Events_Mutation_Response>;
  update_events_by_pk?: Maybe<Events>;
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  update_invitations?: Maybe<Invitations_Mutation_Response>;
  update_invitations_by_pk?: Maybe<Invitations>;
  update_invitations_deleted?: Maybe<Invitations_Deleted_Mutation_Response>;
  update_invitations_deleted_many?: Maybe<Array<Maybe<Invitations_Deleted_Mutation_Response>>>;
  update_invitations_many?: Maybe<Array<Maybe<Invitations_Mutation_Response>>>;
  update_profiles?: Maybe<Profiles_Mutation_Response>;
  update_profiles_by_pk?: Maybe<Profiles>;
  update_profiles_many?: Maybe<Array<Maybe<Profiles_Mutation_Response>>>;
  update_read_receipts?: Maybe<Read_Receipts_Mutation_Response>;
  update_read_receipts_by_pk?: Maybe<Read_Receipts>;
  update_read_receipts_many?: Maybe<Array<Maybe<Read_Receipts_Mutation_Response>>>;
  update_resource_collection_links?: Maybe<Resource_Collection_Links_Mutation_Response>;
  update_resource_collection_links_by_pk?: Maybe<Resource_Collection_Links>;
  update_resource_collection_links_many?: Maybe<Array<Maybe<Resource_Collection_Links_Mutation_Response>>>;
  update_resource_collections?: Maybe<Resource_Collections_Mutation_Response>;
  update_resource_collections_by_pk?: Maybe<Resource_Collections>;
  update_resource_collections_many?: Maybe<Array<Maybe<Resource_Collections_Mutation_Response>>>;
  update_resource_permissions?: Maybe<Resource_Permissions_Mutation_Response>;
  update_resource_permissions_by_pk?: Maybe<Resource_Permissions>;
  update_resource_permissions_many?: Maybe<Array<Maybe<Resource_Permissions_Mutation_Response>>>;
  update_resources?: Maybe<Resources_Mutation_Response>;
  update_resources_by_pk?: Maybe<Resources>;
  update_resources_many?: Maybe<Array<Maybe<Resources_Mutation_Response>>>;
  update_space_apps?: Maybe<Space_Apps_Mutation_Response>;
  update_space_apps_by_pk?: Maybe<Space_Apps>;
  update_space_apps_many?: Maybe<Array<Maybe<Space_Apps_Mutation_Response>>>;
  update_space_members?: Maybe<Space_Members_Mutation_Response>;
  update_space_members_by_pk?: Maybe<Space_Members>;
  update_space_members_deleted?: Maybe<Space_Members_Deleted_Mutation_Response>;
  update_space_members_deleted_many?: Maybe<Array<Maybe<Space_Members_Deleted_Mutation_Response>>>;
  update_space_members_many?: Maybe<Array<Maybe<Space_Members_Mutation_Response>>>;
  update_spaces?: Maybe<Spaces_Mutation_Response>;
  update_spaces_by_pk?: Maybe<Spaces>;
  update_spaces_many?: Maybe<Array<Maybe<Spaces_Mutation_Response>>>;
  update_user_devices?: Maybe<User_Devices_Mutation_Response>;
  update_user_devices_by_pk?: Maybe<User_Devices>;
  update_user_devices_many?: Maybe<Array<Maybe<User_Devices_Mutation_Response>>>;
};


export type Mutation_RootDelete_Access_RequestsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Access_Requests_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_AppsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Apps_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Claim_PrivateArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_ClaimsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Claims_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Collection_PermissionsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Collection_Permissions_By_PkArgs = {
  collection_id: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Mutation_RootDelete_EventsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Events_By_PkArgs = {
  order: Scalars['Any'];
  resource_id: Scalars['Any'];
  sender_key: Scalars['Any'];
  space_session: Scalars['Any'];
};


export type Mutation_RootDelete_InvitationsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Invitations_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Invitations_DeletedArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_ProfilesArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Profiles_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Read_ReceiptsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Read_Receipts_By_PkArgs = {
  space_id: Scalars['Any'];
  user_id: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_Collection_LinksArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_Collection_Links_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_CollectionsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_Collections_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_PermissionsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Resource_Permissions_By_PkArgs = {
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Mutation_RootDelete_ResourcesArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Resources_By_PkArgs = {
  collection_key: Scalars['Any'];
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Space_AppsArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Space_Apps_By_PkArgs = {
  app_name: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Mutation_RootDelete_Space_MembersArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Space_Members_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_Space_Members_DeletedArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_SpacesArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_Spaces_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootDelete_User_DevicesArgs = {
  where: Scalars['Any'];
};


export type Mutation_RootDelete_User_Devices_By_PkArgs = {
  id: Scalars['Any'];
};


export type Mutation_RootInsert_Access_RequestsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Access_Requests_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_AppsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Apps_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Claim_PrivateArgs = {
  objects: Array<Scalars['Any']>;
};


export type Mutation_RootInsert_Claim_Private_OneArgs = {
  object: Scalars['Any'];
};


export type Mutation_RootInsert_ClaimsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Claims_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Collection_PermissionsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Collection_Permissions_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_EventsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Events_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_InvitationsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Invitations_DeletedArgs = {
  objects: Array<Scalars['Any']>;
};


export type Mutation_RootInsert_Invitations_Deleted_OneArgs = {
  object: Scalars['Any'];
};


export type Mutation_RootInsert_Invitations_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_ProfilesArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Profiles_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Read_ReceiptsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Read_Receipts_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_Collection_LinksArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_Collection_Links_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_CollectionsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_Collections_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_PermissionsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resource_Permissions_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_ResourcesArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Resources_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Space_AppsArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Space_Apps_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Space_MembersArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Space_Members_DeletedArgs = {
  objects: Array<Scalars['Any']>;
};


export type Mutation_RootInsert_Space_Members_Deleted_OneArgs = {
  object: Scalars['Any'];
};


export type Mutation_RootInsert_Space_Members_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_SpacesArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_Spaces_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_User_DevicesArgs = {
  objects: Array<Scalars['Any']>;
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootInsert_User_Devices_OneArgs = {
  object: Scalars['Any'];
  on_conflict?: InputMaybe<Scalars['Any']>;
};


export type Mutation_RootUpdate_Access_RequestsArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Access_Requests_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Access_Requests_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_AppsArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Apps_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Apps_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Claim_PrivateArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Claim_Private_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_ClaimsArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Claims_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Claims_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Collection_PermissionsArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Collection_Permissions_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Collection_Permissions_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_EventsArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _inc?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Events_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _inc?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_InvitationsArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Invitations_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Invitations_DeletedArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Invitations_Deleted_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Invitations_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_ProfilesArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Profiles_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Profiles_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Read_ReceiptsArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Read_Receipts_By_PkArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Read_Receipts_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Resource_Collection_LinksArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Collection_Links_By_PkArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Collection_Links_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Resource_CollectionsArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Collections_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Collections_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Resource_PermissionsArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Permissions_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Resource_Permissions_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_ResourcesArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _inc?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Resources_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _inc?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Resources_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Space_AppsArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Space_Apps_By_PkArgs = {
  _inc?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Space_Apps_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Space_MembersArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Space_Members_By_PkArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Space_Members_DeletedArgs = {
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Space_Members_Deleted_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_Space_Members_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_SpacesArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_Spaces_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_Spaces_ManyArgs = {
  updates: Array<Scalars['Any']>;
};


export type Mutation_RootUpdate_User_DevicesArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  where: Scalars['Any'];
};


export type Mutation_RootUpdate_User_Devices_By_PkArgs = {
  _append?: InputMaybe<Scalars['Any']>;
  _delete_at_path?: InputMaybe<Scalars['Any']>;
  _delete_elem?: InputMaybe<Scalars['Any']>;
  _delete_key?: InputMaybe<Scalars['Any']>;
  _prepend?: InputMaybe<Scalars['Any']>;
  _set?: InputMaybe<Scalars['Any']>;
  pk_columns: Scalars['Any'];
};


export type Mutation_RootUpdate_User_Devices_ManyArgs = {
  updates: Array<Scalars['Any']>;
};

export type Notification_Badges = {
  __typename?: 'notification_badges';
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Aggregate = {
  __typename?: 'notification_badges_aggregate';
  aggregate?: Maybe<Notification_Badges_Aggregate_Fields>;
  nodes: Array<Notification_Badges>;
};

export type Notification_Badges_Aggregate_Fields = {
  __typename?: 'notification_badges_aggregate_fields';
  avg?: Maybe<Notification_Badges_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Notification_Badges_Max_Fields>;
  min?: Maybe<Notification_Badges_Min_Fields>;
  stddev?: Maybe<Notification_Badges_Stddev_Fields>;
  stddev_pop?: Maybe<Notification_Badges_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Notification_Badges_Stddev_Samp_Fields>;
  sum?: Maybe<Notification_Badges_Sum_Fields>;
  var_pop?: Maybe<Notification_Badges_Var_Pop_Fields>;
  var_samp?: Maybe<Notification_Badges_Var_Samp_Fields>;
  variance?: Maybe<Notification_Badges_Variance_Fields>;
};


export type Notification_Badges_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Notification_Badges_Avg_Fields = {
  __typename?: 'notification_badges_avg_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Max_Fields = {
  __typename?: 'notification_badges_max_fields';
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Min_Fields = {
  __typename?: 'notification_badges_min_fields';
  user_id?: Maybe<Scalars['Any']>;
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Stddev_Fields = {
  __typename?: 'notification_badges_stddev_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Stddev_Pop_Fields = {
  __typename?: 'notification_badges_stddev_pop_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Stddev_Samp_Fields = {
  __typename?: 'notification_badges_stddev_samp_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Sum_Fields = {
  __typename?: 'notification_badges_sum_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Var_Pop_Fields = {
  __typename?: 'notification_badges_var_pop_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Var_Samp_Fields = {
  __typename?: 'notification_badges_var_samp_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Notification_Badges_Variance_Fields = {
  __typename?: 'notification_badges_variance_fields';
  value?: Maybe<Scalars['Any']>;
};

export type Profiles = {
  __typename?: 'profiles';
  claims: Array<Claims>;
  claims_aggregate: Claims_Aggregate;
  created_at: Scalars['Any'];
  devices: Array<User_Devices>;
  devices_aggregate: User_Devices_Aggregate;
  email?: Maybe<Scalars['Any']>;
  events: Array<Events>;
  events_aggregate: Events_Aggregate;
  id: Scalars['Any'];
  invitations: Array<Invitations>;
  invitationsByUserId: Array<Invitations>;
  invitationsByUserId_aggregate: Invitations_Aggregate;
  invitations_aggregate: Invitations_Aggregate;
  is_invited?: Maybe<Scalars['Any']>;
  latest_change?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  notification_badge?: Maybe<Notification_Badges>;
  personal_space?: Maybe<Spaces>;
  profile_image_path?: Maybe<Scalars['Any']>;
  space_members: Array<Space_Members>;
  space_members_aggregate: Space_Members_Aggregate;
  unread_counts: Array<Unread_Counts>;
  unread_counts_aggregate: Unread_Counts_Aggregate;
  updated_at: Scalars['Any'];
};


export type ProfilesClaimsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesDevicesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesDevices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesEventsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesInvitationsByUserIdArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesInvitationsByUserId_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesSpace_MembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesSpace_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesUnread_CountsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ProfilesUnread_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Profiles_Aggregate = {
  __typename?: 'profiles_aggregate';
  aggregate?: Maybe<Profiles_Aggregate_Fields>;
  nodes: Array<Profiles>;
};

export type Profiles_Aggregate_Fields = {
  __typename?: 'profiles_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Profiles_Max_Fields>;
  min?: Maybe<Profiles_Min_Fields>;
};


export type Profiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Profiles_Max_Fields = {
  __typename?: 'profiles_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  email?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  profile_image_path?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Profiles_Min_Fields = {
  __typename?: 'profiles_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  email?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  profile_image_path?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Profiles_Mutation_Response = {
  __typename?: 'profiles_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Profiles>;
};

export type Query_Root = {
  __typename?: 'query_root';
  access_requests: Array<Access_Requests>;
  access_requests_aggregate: Access_Requests_Aggregate;
  access_requests_by_pk?: Maybe<Access_Requests>;
  apps: Array<Apps>;
  apps_aggregate: Apps_Aggregate;
  apps_by_pk?: Maybe<Apps>;
  chat_list: Array<Chat_List>;
  chat_list_aggregate: Chat_List_Aggregate;
  claim_private: Array<Claim_Private>;
  claim_private_aggregate: Claim_Private_Aggregate;
  claims: Array<Claims>;
  claims_aggregate: Claims_Aggregate;
  claims_by_pk?: Maybe<Claims>;
  collection_permissions: Array<Collection_Permissions>;
  collection_permissions_aggregate: Collection_Permissions_Aggregate;
  collection_permissions_by_pk?: Maybe<Collection_Permissions>;
  events: Array<Events>;
  events_aggregate: Events_Aggregate;
  events_by_pk?: Maybe<Events>;
  invitation_replication: Array<Invitation_Replication>;
  invitation_replication_aggregate: Invitation_Replication_Aggregate;
  invitations: Array<Invitations>;
  invitations_aggregate: Invitations_Aggregate;
  invitations_by_pk?: Maybe<Invitations>;
  invitations_deleted: Array<Invitations_Deleted>;
  invitations_deleted_aggregate: Invitations_Deleted_Aggregate;
  notification_badges: Array<Notification_Badges>;
  notification_badges_aggregate: Notification_Badges_Aggregate;
  profiles: Array<Profiles>;
  profiles_aggregate: Profiles_Aggregate;
  profiles_by_pk?: Maybe<Profiles>;
  read_receipts: Array<Read_Receipts>;
  read_receipts_aggregate: Read_Receipts_Aggregate;
  read_receipts_by_pk?: Maybe<Read_Receipts>;
  resource_collection_links: Array<Resource_Collection_Links>;
  resource_collection_links_aggregate: Resource_Collection_Links_Aggregate;
  resource_collection_links_by_pk?: Maybe<Resource_Collection_Links>;
  resource_collections: Array<Resource_Collections>;
  resource_collections_aggregate: Resource_Collections_Aggregate;
  resource_collections_by_dev_id?: Maybe<Resource_Collections>;
  resource_collections_by_dev_id_aggregate: Resource_Collections_Aggregate;
  resource_collections_by_pk?: Maybe<Resource_Collections>;
  resource_permissions: Array<Resource_Permissions>;
  resource_permissions_aggregate: Resource_Permissions_Aggregate;
  resource_permissions_by_pk?: Maybe<Resource_Permissions>;
  resources: Array<Resources>;
  resources_aggregate: Resources_Aggregate;
  resources_by_pk?: Maybe<Resources>;
  resources_query_v1: Array<Resources>;
  resources_query_v1_aggregate: Resources_Aggregate;
  resources_query_v2: Array<Resources>;
  resources_query_v2_aggregate: Resources_Aggregate;
  space_apps: Array<Space_Apps>;
  space_apps_aggregate: Space_Apps_Aggregate;
  space_apps_by_pk?: Maybe<Space_Apps>;
  space_member_replication: Array<Space_Member_Replication>;
  space_member_replication_aggregate: Space_Member_Replication_Aggregate;
  space_members: Array<Space_Members>;
  space_members_active: Array<Space_Members_Active>;
  space_members_active_aggregate: Space_Members_Active_Aggregate;
  space_members_aggregate: Space_Members_Aggregate;
  space_members_by_pk?: Maybe<Space_Members>;
  space_members_deleted: Array<Space_Members_Deleted>;
  space_members_deleted_aggregate: Space_Members_Deleted_Aggregate;
  spaces: Array<Spaces>;
  spaces_aggregate: Spaces_Aggregate;
  spaces_by_pk?: Maybe<Spaces>;
  unified_resource_permissions: Array<Unified_Resource_Permissions>;
  unified_resource_permissions_aggregate: Unified_Resource_Permissions_Aggregate;
  unread_counts: Array<Unread_Counts>;
  unread_counts_aggregate: Unread_Counts_Aggregate;
  user_devices: Array<User_Devices>;
  user_devices_aggregate: User_Devices_Aggregate;
  user_devices_by_pk?: Maybe<User_Devices>;
};


export type Query_RootAccess_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootAccess_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootAccess_Requests_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootAppsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootApps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootApps_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootChat_ListArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootChat_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootClaim_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootClaim_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootClaimsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootClaims_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootCollection_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootCollection_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootCollection_Permissions_By_PkArgs = {
  collection_id: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootEvents_By_PkArgs = {
  order: Scalars['Any'];
  resource_id: Scalars['Any'];
  sender_key: Scalars['Any'];
  space_session: Scalars['Any'];
};


export type Query_RootInvitation_ReplicationArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootInvitation_Replication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootInvitations_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootInvitations_DeletedArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootInvitations_Deleted_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootNotification_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootNotification_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootProfilesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootProfiles_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootRead_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootRead_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootRead_Receipts_By_PkArgs = {
  space_id: Scalars['Any'];
  user_id: Scalars['Any'];
};


export type Query_RootResource_Collection_LinksArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collection_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collection_Links_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootResource_CollectionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collections_By_Dev_IdArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collections_By_Dev_Id_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Collections_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootResource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResource_Permissions_By_PkArgs = {
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Query_RootResourcesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResources_By_PkArgs = {
  collection_key: Scalars['Any'];
  id: Scalars['Any'];
};


export type Query_RootResources_Query_V1Args = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResources_Query_V1_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResources_Query_V2Args = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootResources_Query_V2_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_AppsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Apps_By_PkArgs = {
  app_name: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Query_RootSpace_Member_ReplicationArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Member_Replication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_MembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Members_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Members_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Members_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootSpace_Members_DeletedArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpace_Members_Deleted_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpacesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootSpaces_By_PkArgs = {
  id: Scalars['Any'];
};


export type Query_RootUnified_Resource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUnified_Resource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUnread_CountsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUnread_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUser_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUser_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Query_RootUser_Devices_By_PkArgs = {
  id: Scalars['Any'];
};

export type Read_Receipts = {
  __typename?: 'read_receipts';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_sender_key?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
  last_seen_user_key?: Maybe<Scalars['Any']>;
  space: Spaces;
  space_id: Scalars['Any'];
  timestamp: Scalars['Any'];
  user_id: Scalars['Any'];
};

export type Read_Receipts_Aggregate = {
  __typename?: 'read_receipts_aggregate';
  aggregate?: Maybe<Read_Receipts_Aggregate_Fields>;
  nodes: Array<Read_Receipts>;
};

export type Read_Receipts_Aggregate_Fields = {
  __typename?: 'read_receipts_aggregate_fields';
  avg?: Maybe<Read_Receipts_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Read_Receipts_Max_Fields>;
  min?: Maybe<Read_Receipts_Min_Fields>;
  stddev?: Maybe<Read_Receipts_Stddev_Fields>;
  stddev_pop?: Maybe<Read_Receipts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Read_Receipts_Stddev_Samp_Fields>;
  sum?: Maybe<Read_Receipts_Sum_Fields>;
  var_pop?: Maybe<Read_Receipts_Var_Pop_Fields>;
  var_samp?: Maybe<Read_Receipts_Var_Samp_Fields>;
  variance?: Maybe<Read_Receipts_Variance_Fields>;
};


export type Read_Receipts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Read_Receipts_Avg_Fields = {
  __typename?: 'read_receipts_avg_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Max_Fields = {
  __typename?: 'read_receipts_max_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_sender_key?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
  last_seen_user_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  timestamp?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Min_Fields = {
  __typename?: 'read_receipts_min_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_sender_key?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
  last_seen_user_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  timestamp?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Mutation_Response = {
  __typename?: 'read_receipts_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Read_Receipts>;
};

export type Read_Receipts_Stddev_Fields = {
  __typename?: 'read_receipts_stddev_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Stddev_Pop_Fields = {
  __typename?: 'read_receipts_stddev_pop_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Stddev_Samp_Fields = {
  __typename?: 'read_receipts_stddev_samp_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Sum_Fields = {
  __typename?: 'read_receipts_sum_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Var_Pop_Fields = {
  __typename?: 'read_receipts_var_pop_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Var_Samp_Fields = {
  __typename?: 'read_receipts_var_samp_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Read_Receipts_Variance_Fields = {
  __typename?: 'read_receipts_variance_fields';
  last_seen_order?: Maybe<Scalars['Any']>;
  last_seen_space_session?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links = {
  __typename?: 'resource_collection_links';
  collection: Resource_Collections;
  collection_id: Scalars['Any'];
  id: Scalars['Any'];
  resource: Resources;
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
};

export type Resource_Collection_Links_Aggregate = {
  __typename?: 'resource_collection_links_aggregate';
  aggregate?: Maybe<Resource_Collection_Links_Aggregate_Fields>;
  nodes: Array<Resource_Collection_Links>;
};

export type Resource_Collection_Links_Aggregate_Fields = {
  __typename?: 'resource_collection_links_aggregate_fields';
  avg?: Maybe<Resource_Collection_Links_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Resource_Collection_Links_Max_Fields>;
  min?: Maybe<Resource_Collection_Links_Min_Fields>;
  stddev?: Maybe<Resource_Collection_Links_Stddev_Fields>;
  stddev_pop?: Maybe<Resource_Collection_Links_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resource_Collection_Links_Stddev_Samp_Fields>;
  sum?: Maybe<Resource_Collection_Links_Sum_Fields>;
  var_pop?: Maybe<Resource_Collection_Links_Var_Pop_Fields>;
  var_samp?: Maybe<Resource_Collection_Links_Var_Samp_Fields>;
  variance?: Maybe<Resource_Collection_Links_Variance_Fields>;
};


export type Resource_Collection_Links_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Avg_Fields = {
  __typename?: 'resource_collection_links_avg_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Max_Fields = {
  __typename?: 'resource_collection_links_max_fields';
  collection_id?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Min_Fields = {
  __typename?: 'resource_collection_links_min_fields';
  collection_id?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Mutation_Response = {
  __typename?: 'resource_collection_links_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Resource_Collection_Links>;
};

export type Resource_Collection_Links_Stddev_Fields = {
  __typename?: 'resource_collection_links_stddev_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Stddev_Pop_Fields = {
  __typename?: 'resource_collection_links_stddev_pop_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Stddev_Samp_Fields = {
  __typename?: 'resource_collection_links_stddev_samp_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Sum_Fields = {
  __typename?: 'resource_collection_links_sum_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Var_Pop_Fields = {
  __typename?: 'resource_collection_links_var_pop_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Var_Samp_Fields = {
  __typename?: 'resource_collection_links_var_samp_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collection_Links_Variance_Fields = {
  __typename?: 'resource_collection_links_variance_fields';
  id?: Maybe<Scalars['Any']>;
};

export type Resource_Collections = {
  __typename?: 'resource_collections';
  created_at?: Maybe<Scalars['Any']>;
  dev_id: Scalars['Any'];
  id: Scalars['Any'];
  name: Scalars['Any'];
  permissions: Array<Collection_Permissions>;
  permissions_aggregate: Collection_Permissions_Aggregate;
  resources: Array<Resource_Collection_Links>;
  resources_aggregate: Resource_Collection_Links_Aggregate;
  updated_at?: Maybe<Scalars['Any']>;
};


export type Resource_CollectionsPermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Resource_CollectionsPermissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Resource_CollectionsResourcesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Resource_CollectionsResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Resource_Collections_Aggregate = {
  __typename?: 'resource_collections_aggregate';
  aggregate?: Maybe<Resource_Collections_Aggregate_Fields>;
  nodes: Array<Resource_Collections>;
};

export type Resource_Collections_Aggregate_Fields = {
  __typename?: 'resource_collections_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Resource_Collections_Max_Fields>;
  min?: Maybe<Resource_Collections_Min_Fields>;
};


export type Resource_Collections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Resource_Collections_Max_Fields = {
  __typename?: 'resource_collections_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  dev_id?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Resource_Collections_Min_Fields = {
  __typename?: 'resource_collections_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  dev_id?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Resource_Collections_Mutation_Response = {
  __typename?: 'resource_collections_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Resource_Collections>;
};

export type Resource_Permissions = {
  __typename?: 'resource_permissions';
  created_at: Scalars['Any'];
  resource?: Maybe<Resources>;
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
  space: Spaces;
  space_id: Scalars['Any'];
};

export type Resource_Permissions_Aggregate = {
  __typename?: 'resource_permissions_aggregate';
  aggregate?: Maybe<Resource_Permissions_Aggregate_Fields>;
  nodes: Array<Resource_Permissions>;
};

export type Resource_Permissions_Aggregate_Fields = {
  __typename?: 'resource_permissions_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Resource_Permissions_Max_Fields>;
  min?: Maybe<Resource_Permissions_Min_Fields>;
};


export type Resource_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Resource_Permissions_Max_Fields = {
  __typename?: 'resource_permissions_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Resource_Permissions_Min_Fields = {
  __typename?: 'resource_permissions_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Resource_Permissions_Mutation_Response = {
  __typename?: 'resource_permissions_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Resource_Permissions>;
};

export type Resources = {
  __typename?: 'resources';
  collection_key: Scalars['Any'];
  collections: Array<Resource_Collection_Links>;
  collections_aggregate: Resource_Collection_Links_Aggregate;
  created_at: Scalars['Any'];
  data?: Maybe<Scalars['Any']>;
  id: Scalars['Any'];
  initialized: Scalars['Any'];
  initialized_at?: Maybe<Scalars['Any']>;
  last_processed: Scalars['Any'];
  local_id?: Maybe<Scalars['Any']>;
  resource_permissions: Array<Resource_Permissions>;
  resource_permissions_aggregate: Resource_Permissions_Aggregate;
  session_num: Scalars['Any'];
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at: Scalars['Any'];
};


export type ResourcesCollectionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ResourcesCollections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ResourcesDataArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type ResourcesResource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type ResourcesResource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Resources_Aggregate = {
  __typename?: 'resources_aggregate';
  aggregate?: Maybe<Resources_Aggregate_Fields>;
  nodes: Array<Resources>;
};

export type Resources_Aggregate_Fields = {
  __typename?: 'resources_aggregate_fields';
  avg?: Maybe<Resources_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Resources_Max_Fields>;
  min?: Maybe<Resources_Min_Fields>;
  stddev?: Maybe<Resources_Stddev_Fields>;
  stddev_pop?: Maybe<Resources_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resources_Stddev_Samp_Fields>;
  sum?: Maybe<Resources_Sum_Fields>;
  var_pop?: Maybe<Resources_Var_Pop_Fields>;
  var_samp?: Maybe<Resources_Var_Samp_Fields>;
  variance?: Maybe<Resources_Variance_Fields>;
};


export type Resources_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Resources_Avg_Fields = {
  __typename?: 'resources_avg_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Max_Fields = {
  __typename?: 'resources_max_fields';
  collection_key?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  initialized_at?: Maybe<Scalars['Any']>;
  last_processed?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Resources_Min_Fields = {
  __typename?: 'resources_min_fields';
  collection_key?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  initialized_at?: Maybe<Scalars['Any']>;
  last_processed?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Resources_Mutation_Response = {
  __typename?: 'resources_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Resources>;
};

export type Resources_Stddev_Fields = {
  __typename?: 'resources_stddev_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Stddev_Pop_Fields = {
  __typename?: 'resources_stddev_pop_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Stddev_Samp_Fields = {
  __typename?: 'resources_stddev_samp_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Sum_Fields = {
  __typename?: 'resources_sum_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Var_Pop_Fields = {
  __typename?: 'resources_var_pop_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Var_Samp_Fields = {
  __typename?: 'resources_var_samp_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Resources_Variance_Fields = {
  __typename?: 'resources_variance_fields';
  last_processed?: Maybe<Scalars['Any']>;
  session_num?: Maybe<Scalars['Any']>;
};

export type Space_Apps = {
  __typename?: 'space_apps';
  app: Apps;
  app_name: Scalars['Any'];
  created_at?: Maybe<Scalars['Any']>;
  fractional_index: Scalars['Any'];
  space: Spaces;
  space_id: Scalars['Any'];
  title?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Aggregate = {
  __typename?: 'space_apps_aggregate';
  aggregate?: Maybe<Space_Apps_Aggregate_Fields>;
  nodes: Array<Space_Apps>;
};

export type Space_Apps_Aggregate_Fields = {
  __typename?: 'space_apps_aggregate_fields';
  avg?: Maybe<Space_Apps_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Space_Apps_Max_Fields>;
  min?: Maybe<Space_Apps_Min_Fields>;
  stddev?: Maybe<Space_Apps_Stddev_Fields>;
  stddev_pop?: Maybe<Space_Apps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Space_Apps_Stddev_Samp_Fields>;
  sum?: Maybe<Space_Apps_Sum_Fields>;
  var_pop?: Maybe<Space_Apps_Var_Pop_Fields>;
  var_samp?: Maybe<Space_Apps_Var_Samp_Fields>;
  variance?: Maybe<Space_Apps_Variance_Fields>;
};


export type Space_Apps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Space_Apps_Avg_Fields = {
  __typename?: 'space_apps_avg_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Max_Fields = {
  __typename?: 'space_apps_max_fields';
  app_name?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  fractional_index?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  title?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Min_Fields = {
  __typename?: 'space_apps_min_fields';
  app_name?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  fractional_index?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  title?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Mutation_Response = {
  __typename?: 'space_apps_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Space_Apps>;
};

export type Space_Apps_Stddev_Fields = {
  __typename?: 'space_apps_stddev_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Stddev_Pop_Fields = {
  __typename?: 'space_apps_stddev_pop_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Stddev_Samp_Fields = {
  __typename?: 'space_apps_stddev_samp_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Sum_Fields = {
  __typename?: 'space_apps_sum_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Var_Pop_Fields = {
  __typename?: 'space_apps_var_pop_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Var_Samp_Fields = {
  __typename?: 'space_apps_var_samp_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Apps_Variance_Fields = {
  __typename?: 'space_apps_variance_fields';
  fractional_index?: Maybe<Scalars['Any']>;
};

export type Space_Member_Replication = {
  __typename?: 'space_member_replication';
  Member?: Maybe<Profiles>;
  claim?: Maybe<Claims>;
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  deleted?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  latest_message?: Maybe<Array<Events>>;
  local_id?: Maybe<Scalars['Any']>;
  replication_timestamp?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};


export type Space_Member_ReplicationLatest_MessageArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Space_Member_Replication_Aggregate = {
  __typename?: 'space_member_replication_aggregate';
  aggregate?: Maybe<Space_Member_Replication_Aggregate_Fields>;
  nodes: Array<Space_Member_Replication>;
};

export type Space_Member_Replication_Aggregate_Fields = {
  __typename?: 'space_member_replication_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Space_Member_Replication_Max_Fields>;
  min?: Maybe<Space_Member_Replication_Min_Fields>;
};


export type Space_Member_Replication_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Space_Member_Replication_Max_Fields = {
  __typename?: 'space_member_replication_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Member_Replication_Min_Fields = {
  __typename?: 'space_member_replication_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members = {
  __typename?: 'space_members';
  claim?: Maybe<Claims>;
  claim_id?: Maybe<Scalars['Any']>;
  created_at: Scalars['Any'];
  fallback_space_name?: Maybe<Scalars['Any']>;
  id: Scalars['Any'];
  invitation?: Maybe<Invitations>;
  invitation_id?: Maybe<Scalars['Any']>;
  latest_message?: Maybe<Array<Events>>;
  local_id?: Maybe<Scalars['Any']>;
  member?: Maybe<Profiles>;
  mute_notifications: Scalars['Any'];
  role?: Maybe<Scalars['Any']>;
  space: Spaces;
  space_id: Scalars['Any'];
  updated_at: Scalars['Any'];
  user_id?: Maybe<Scalars['Any']>;
};


export type Space_MembersLatest_MessageArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Space_Members_Active = {
  __typename?: 'space_members_active';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  fallback_space_name?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  member?: Maybe<Profiles>;
  mute_notifications?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Active_Aggregate = {
  __typename?: 'space_members_active_aggregate';
  aggregate?: Maybe<Space_Members_Active_Aggregate_Fields>;
  nodes: Array<Space_Members_Active>;
};

export type Space_Members_Active_Aggregate_Fields = {
  __typename?: 'space_members_active_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Space_Members_Active_Max_Fields>;
  min?: Maybe<Space_Members_Active_Min_Fields>;
};


export type Space_Members_Active_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Space_Members_Active_Max_Fields = {
  __typename?: 'space_members_active_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Active_Min_Fields = {
  __typename?: 'space_members_active_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Aggregate = {
  __typename?: 'space_members_aggregate';
  aggregate?: Maybe<Space_Members_Aggregate_Fields>;
  nodes: Array<Space_Members>;
};

export type Space_Members_Aggregate_Fields = {
  __typename?: 'space_members_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Space_Members_Max_Fields>;
  min?: Maybe<Space_Members_Min_Fields>;
};


export type Space_Members_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Space_Members_Deleted = {
  __typename?: 'space_members_deleted';
  claim_id?: Maybe<Scalars['Any']>;
  created_at: Scalars['Any'];
  id: Scalars['Any'];
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  mute_notifications: Scalars['Any'];
  role?: Maybe<Scalars['Any']>;
  space_id: Scalars['Any'];
  updated_at: Scalars['Any'];
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Deleted_Aggregate = {
  __typename?: 'space_members_deleted_aggregate';
  aggregate?: Maybe<Space_Members_Deleted_Aggregate_Fields>;
  nodes: Array<Space_Members_Deleted>;
};

export type Space_Members_Deleted_Aggregate_Fields = {
  __typename?: 'space_members_deleted_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Space_Members_Deleted_Max_Fields>;
  min?: Maybe<Space_Members_Deleted_Min_Fields>;
};


export type Space_Members_Deleted_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Space_Members_Deleted_Max_Fields = {
  __typename?: 'space_members_deleted_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Deleted_Min_Fields = {
  __typename?: 'space_members_deleted_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Deleted_Mutation_Response = {
  __typename?: 'space_members_deleted_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Space_Members_Deleted>;
};

export type Space_Members_Max_Fields = {
  __typename?: 'space_members_max_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Min_Fields = {
  __typename?: 'space_members_min_fields';
  claim_id?: Maybe<Scalars['Any']>;
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  invitation_id?: Maybe<Scalars['Any']>;
  local_id?: Maybe<Scalars['Any']>;
  role?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Space_Members_Mutation_Response = {
  __typename?: 'space_members_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Space_Members>;
};

export type Spaces = {
  __typename?: 'spaces';
  active_members: Array<Space_Members_Active>;
  active_members_aggregate: Space_Members_Active_Aggregate;
  apps: Array<Space_Apps>;
  apps_aggregate: Space_Apps_Aggregate;
  collection_permissions: Array<Collection_Permissions>;
  collection_permissions_aggregate: Collection_Permissions_Aggregate;
  cover_photo?: Maybe<Scalars['Any']>;
  created_at: Scalars['Any'];
  current_user_is_member?: Maybe<Scalars['Any']>;
  deleted: Scalars['Any'];
  display_name?: Maybe<Scalars['Any']>;
  events: Array<Events>;
  events_aggregate: Events_Aggregate;
  id: Scalars['Any'];
  invitations: Array<Invitations>;
  invitations_aggregate: Invitations_Aggregate;
  join_id?: Maybe<Scalars['Any']>;
  latest_app_updated_at?: Maybe<Scalars['Any']>;
  latest_invitation_time?: Maybe<Scalars['Any']>;
  latest_membership_time?: Maybe<Scalars['Any']>;
  latest_message_time?: Maybe<Scalars['Any']>;
  members: Array<Space_Members>;
  members_aggregate: Space_Members_Aggregate;
  name?: Maybe<Scalars['Any']>;
  private_space_owner_id?: Maybe<Scalars['Any']>;
  resource_permissions: Array<Resource_Permissions>;
  resource_permissions_aggregate: Resource_Permissions_Aggregate;
  resources: Array<Resources>;
  resources_aggregate: Resources_Aggregate;
  type?: Maybe<Scalars['Any']>;
  unread_counts?: Maybe<Unread_Counts>;
  updated_at: Scalars['Any'];
};


export type SpacesActive_MembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesActive_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesAppsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesApps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesCollection_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesCollection_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesCover_PhotoArgs = {
  path?: InputMaybe<Scalars['Any']>;
};


export type SpacesEventsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesMembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesResource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesResource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesResourcesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type SpacesResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Spaces_Aggregate = {
  __typename?: 'spaces_aggregate';
  aggregate?: Maybe<Spaces_Aggregate_Fields>;
  nodes: Array<Spaces>;
};

export type Spaces_Aggregate_Fields = {
  __typename?: 'spaces_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Spaces_Max_Fields>;
  min?: Maybe<Spaces_Min_Fields>;
};


export type Spaces_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Spaces_Max_Fields = {
  __typename?: 'spaces_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  join_id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  private_space_owner_id?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Spaces_Min_Fields = {
  __typename?: 'spaces_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  join_id?: Maybe<Scalars['Any']>;
  name?: Maybe<Scalars['Any']>;
  private_space_owner_id?: Maybe<Scalars['Any']>;
  type?: Maybe<Scalars['Any']>;
  updated_at?: Maybe<Scalars['Any']>;
};

export type Spaces_Mutation_Response = {
  __typename?: 'spaces_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<Spaces>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  access_requests: Array<Access_Requests>;
  access_requests_aggregate: Access_Requests_Aggregate;
  access_requests_by_pk?: Maybe<Access_Requests>;
  access_requests_stream: Array<Access_Requests>;
  apps: Array<Apps>;
  apps_aggregate: Apps_Aggregate;
  apps_by_pk?: Maybe<Apps>;
  apps_stream: Array<Apps>;
  chat_list: Array<Chat_List>;
  chat_list_aggregate: Chat_List_Aggregate;
  chat_list_stream: Array<Chat_List>;
  claim_private: Array<Claim_Private>;
  claim_private_aggregate: Claim_Private_Aggregate;
  claim_private_stream: Array<Claim_Private>;
  claims: Array<Claims>;
  claims_aggregate: Claims_Aggregate;
  claims_by_pk?: Maybe<Claims>;
  claims_stream: Array<Claims>;
  collection_permissions: Array<Collection_Permissions>;
  collection_permissions_aggregate: Collection_Permissions_Aggregate;
  collection_permissions_by_pk?: Maybe<Collection_Permissions>;
  collection_permissions_stream: Array<Collection_Permissions>;
  events: Array<Events>;
  events_aggregate: Events_Aggregate;
  events_by_pk?: Maybe<Events>;
  events_stream: Array<Events>;
  invitation_replication: Array<Invitation_Replication>;
  invitation_replication_aggregate: Invitation_Replication_Aggregate;
  invitation_replication_stream: Array<Invitation_Replication>;
  invitations: Array<Invitations>;
  invitations_aggregate: Invitations_Aggregate;
  invitations_by_pk?: Maybe<Invitations>;
  invitations_deleted: Array<Invitations_Deleted>;
  invitations_deleted_aggregate: Invitations_Deleted_Aggregate;
  invitations_deleted_stream: Array<Invitations_Deleted>;
  invitations_stream: Array<Invitations>;
  notification_badges: Array<Notification_Badges>;
  notification_badges_aggregate: Notification_Badges_Aggregate;
  notification_badges_stream: Array<Notification_Badges>;
  profiles: Array<Profiles>;
  profiles_aggregate: Profiles_Aggregate;
  profiles_by_pk?: Maybe<Profiles>;
  profiles_stream: Array<Profiles>;
  read_receipts: Array<Read_Receipts>;
  read_receipts_aggregate: Read_Receipts_Aggregate;
  read_receipts_by_pk?: Maybe<Read_Receipts>;
  read_receipts_stream: Array<Read_Receipts>;
  resource_collection_links: Array<Resource_Collection_Links>;
  resource_collection_links_aggregate: Resource_Collection_Links_Aggregate;
  resource_collection_links_by_pk?: Maybe<Resource_Collection_Links>;
  resource_collection_links_stream: Array<Resource_Collection_Links>;
  resource_collections: Array<Resource_Collections>;
  resource_collections_aggregate: Resource_Collections_Aggregate;
  resource_collections_by_dev_id?: Maybe<Resource_Collections>;
  resource_collections_by_dev_id_aggregate: Resource_Collections_Aggregate;
  resource_collections_by_pk?: Maybe<Resource_Collections>;
  resource_collections_stream: Array<Resource_Collections>;
  resource_permissions: Array<Resource_Permissions>;
  resource_permissions_aggregate: Resource_Permissions_Aggregate;
  resource_permissions_by_pk?: Maybe<Resource_Permissions>;
  resource_permissions_stream: Array<Resource_Permissions>;
  resources: Array<Resources>;
  resources_aggregate: Resources_Aggregate;
  resources_by_pk?: Maybe<Resources>;
  resources_query_v1: Array<Resources>;
  resources_query_v1_aggregate: Resources_Aggregate;
  resources_query_v2: Array<Resources>;
  resources_query_v2_aggregate: Resources_Aggregate;
  resources_stream: Array<Resources>;
  space_apps: Array<Space_Apps>;
  space_apps_aggregate: Space_Apps_Aggregate;
  space_apps_by_pk?: Maybe<Space_Apps>;
  space_apps_stream: Array<Space_Apps>;
  space_member_replication: Array<Space_Member_Replication>;
  space_member_replication_aggregate: Space_Member_Replication_Aggregate;
  space_member_replication_stream: Array<Space_Member_Replication>;
  space_members: Array<Space_Members>;
  space_members_active: Array<Space_Members_Active>;
  space_members_active_aggregate: Space_Members_Active_Aggregate;
  space_members_active_stream: Array<Space_Members_Active>;
  space_members_aggregate: Space_Members_Aggregate;
  space_members_by_pk?: Maybe<Space_Members>;
  space_members_deleted: Array<Space_Members_Deleted>;
  space_members_deleted_aggregate: Space_Members_Deleted_Aggregate;
  space_members_deleted_stream: Array<Space_Members_Deleted>;
  space_members_stream: Array<Space_Members>;
  spaces: Array<Spaces>;
  spaces_aggregate: Spaces_Aggregate;
  spaces_by_pk?: Maybe<Spaces>;
  spaces_stream: Array<Spaces>;
  unified_resource_permissions: Array<Unified_Resource_Permissions>;
  unified_resource_permissions_aggregate: Unified_Resource_Permissions_Aggregate;
  unified_resource_permissions_stream: Array<Unified_Resource_Permissions>;
  unread_counts: Array<Unread_Counts>;
  unread_counts_aggregate: Unread_Counts_Aggregate;
  unread_counts_stream: Array<Unread_Counts>;
  user_devices: Array<User_Devices>;
  user_devices_aggregate: User_Devices_Aggregate;
  user_devices_by_pk?: Maybe<User_Devices>;
  user_devices_stream: Array<User_Devices>;
};


export type Subscription_RootAccess_RequestsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootAccess_Requests_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootAccess_Requests_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootAccess_Requests_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootAppsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootApps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootApps_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootApps_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootChat_ListArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootChat_List_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootChat_List_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaim_PrivateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaim_Private_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaim_Private_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaimsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaims_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootClaims_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootClaims_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootCollection_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootCollection_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootCollection_Permissions_By_PkArgs = {
  collection_id: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Subscription_RootCollection_Permissions_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootEvents_By_PkArgs = {
  order: Scalars['Any'];
  resource_id: Scalars['Any'];
  sender_key: Scalars['Any'];
  space_session: Scalars['Any'];
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitation_ReplicationArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitation_Replication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitation_Replication_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitationsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitations_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootInvitations_DeletedArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitations_Deleted_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitations_Deleted_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootInvitations_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootNotification_BadgesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootNotification_Badges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootNotification_Badges_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootProfilesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootProfiles_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootProfiles_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootRead_ReceiptsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootRead_Receipts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootRead_Receipts_By_PkArgs = {
  space_id: Scalars['Any'];
  user_id: Scalars['Any'];
};


export type Subscription_RootRead_Receipts_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collection_LinksArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collection_Links_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collection_Links_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootResource_Collection_Links_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_CollectionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collections_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collections_By_Dev_IdArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collections_By_Dev_Id_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Collections_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootResource_Collections_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResource_Permissions_By_PkArgs = {
  resource_id: Scalars['Any'];
  resource_key: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Subscription_RootResource_Permissions_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResourcesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_By_PkArgs = {
  collection_key: Scalars['Any'];
  id: Scalars['Any'];
};


export type Subscription_RootResources_Query_V1Args = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_Query_V1_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_Query_V2Args = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_Query_V2_AggregateArgs = {
  args: Scalars['Any'];
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootResources_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_AppsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Apps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Apps_By_PkArgs = {
  app_name: Scalars['Any'];
  space_id: Scalars['Any'];
};


export type Subscription_RootSpace_Apps_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Member_ReplicationArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Member_Replication_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Member_Replication_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_MembersArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_ActiveArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_Active_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_Active_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootSpace_Members_DeletedArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_Deleted_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_Deleted_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpace_Members_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpacesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpaces_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootSpaces_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootSpaces_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnified_Resource_PermissionsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnified_Resource_Permissions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnified_Resource_Permissions_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnread_CountsArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnread_Counts_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUnread_Counts_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUser_DevicesArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUser_Devices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scalars['Any']>>;
  limit?: InputMaybe<Scalars['Any']>;
  offset?: InputMaybe<Scalars['Any']>;
  order_by?: InputMaybe<Array<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};


export type Subscription_RootUser_Devices_By_PkArgs = {
  id: Scalars['Any'];
};


export type Subscription_RootUser_Devices_StreamArgs = {
  batch_size: Scalars['Any'];
  cursor: Array<InputMaybe<Scalars['Any']>>;
  where?: InputMaybe<Scalars['Any']>;
};

export type Unified_Resource_Permissions = {
  __typename?: 'unified_resource_permissions';
  resource?: Maybe<Resources>;
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Unified_Resource_Permissions_Aggregate = {
  __typename?: 'unified_resource_permissions_aggregate';
  aggregate?: Maybe<Unified_Resource_Permissions_Aggregate_Fields>;
  nodes: Array<Unified_Resource_Permissions>;
};

export type Unified_Resource_Permissions_Aggregate_Fields = {
  __typename?: 'unified_resource_permissions_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<Unified_Resource_Permissions_Max_Fields>;
  min?: Maybe<Unified_Resource_Permissions_Min_Fields>;
};


export type Unified_Resource_Permissions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Unified_Resource_Permissions_Max_Fields = {
  __typename?: 'unified_resource_permissions_max_fields';
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Unified_Resource_Permissions_Min_Fields = {
  __typename?: 'unified_resource_permissions_min_fields';
  resource_id?: Maybe<Scalars['Any']>;
  resource_key?: Maybe<Scalars['Any']>;
  space_id?: Maybe<Scalars['Any']>;
};

export type Unread_Counts = {
  __typename?: 'unread_counts';
  space?: Maybe<Spaces>;
  space_id?: Maybe<Scalars['Any']>;
  unread_count?: Maybe<Scalars['Any']>;
  user?: Maybe<Profiles>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Aggregate = {
  __typename?: 'unread_counts_aggregate';
  aggregate?: Maybe<Unread_Counts_Aggregate_Fields>;
  nodes: Array<Unread_Counts>;
};

export type Unread_Counts_Aggregate_Fields = {
  __typename?: 'unread_counts_aggregate_fields';
  avg?: Maybe<Unread_Counts_Avg_Fields>;
  count: Scalars['Any'];
  max?: Maybe<Unread_Counts_Max_Fields>;
  min?: Maybe<Unread_Counts_Min_Fields>;
  stddev?: Maybe<Unread_Counts_Stddev_Fields>;
  stddev_pop?: Maybe<Unread_Counts_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Unread_Counts_Stddev_Samp_Fields>;
  sum?: Maybe<Unread_Counts_Sum_Fields>;
  var_pop?: Maybe<Unread_Counts_Var_Pop_Fields>;
  var_samp?: Maybe<Unread_Counts_Var_Samp_Fields>;
  variance?: Maybe<Unread_Counts_Variance_Fields>;
};


export type Unread_Counts_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type Unread_Counts_Avg_Fields = {
  __typename?: 'unread_counts_avg_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Max_Fields = {
  __typename?: 'unread_counts_max_fields';
  space_id?: Maybe<Scalars['Any']>;
  unread_count?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Min_Fields = {
  __typename?: 'unread_counts_min_fields';
  space_id?: Maybe<Scalars['Any']>;
  unread_count?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Stddev_Fields = {
  __typename?: 'unread_counts_stddev_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Stddev_Pop_Fields = {
  __typename?: 'unread_counts_stddev_pop_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Stddev_Samp_Fields = {
  __typename?: 'unread_counts_stddev_samp_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Sum_Fields = {
  __typename?: 'unread_counts_sum_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Var_Pop_Fields = {
  __typename?: 'unread_counts_var_pop_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Var_Samp_Fields = {
  __typename?: 'unread_counts_var_samp_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type Unread_Counts_Variance_Fields = {
  __typename?: 'unread_counts_variance_fields';
  unread_count?: Maybe<Scalars['Any']>;
};

export type User_Devices = {
  __typename?: 'user_devices';
  created_at: Scalars['Any'];
  expo_notification_token: Scalars['Any'];
  host_info: Scalars['Any'];
  id: Scalars['Any'];
  profile: Profiles;
  user_id: Scalars['Any'];
};


export type User_DevicesHost_InfoArgs = {
  path?: InputMaybe<Scalars['Any']>;
};

export type User_Devices_Aggregate = {
  __typename?: 'user_devices_aggregate';
  aggregate?: Maybe<User_Devices_Aggregate_Fields>;
  nodes: Array<User_Devices>;
};

export type User_Devices_Aggregate_Fields = {
  __typename?: 'user_devices_aggregate_fields';
  count: Scalars['Any'];
  max?: Maybe<User_Devices_Max_Fields>;
  min?: Maybe<User_Devices_Min_Fields>;
};


export type User_Devices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scalars['Any']>>;
  distinct?: InputMaybe<Scalars['Any']>;
};

export type User_Devices_Max_Fields = {
  __typename?: 'user_devices_max_fields';
  created_at?: Maybe<Scalars['Any']>;
  expo_notification_token?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type User_Devices_Min_Fields = {
  __typename?: 'user_devices_min_fields';
  created_at?: Maybe<Scalars['Any']>;
  expo_notification_token?: Maybe<Scalars['Any']>;
  id?: Maybe<Scalars['Any']>;
  user_id?: Maybe<Scalars['Any']>;
};

export type User_Devices_Mutation_Response = {
  __typename?: 'user_devices_mutation_response';
  affected_rows: Scalars['Any'];
  returning: Array<User_Devices>;
};

export type MakeAccessRequestMutationVariables = Exact<{
  requester_id: Uuid;
  recipient_id: Uuid;
  space_id: Uuid;
  resource_type: Scalars['String'];
  metadata: Jsonb;
  key: Scalars['String'];
}>;


export type MakeAccessRequestMutation = { __typename?: 'mutation_root', insert_access_requests_one?: { __typename?: 'access_requests', id: any } | null };

export type GetAccessRequestsQueryVariables = Exact<{
  resource_type: Scalars['String'];
  key: Scalars['String'];
}>;


export type GetAccessRequestsQuery = { __typename?: 'query_root', access_requests: Array<{ __typename?: 'access_requests', id: any, key: any, created_at: any, metadata?: any | null, recipient_id: any, requester_id: any, resource_type: any, space_id: any }> };

export type UnreadCountInfoFragment = { __typename?: 'unread_counts', space_id?: any | null, unread_count?: any | null };

export type ChatListItemFragment = { __typename?: 'chat_list', cover_photo?: any | null, id?: any | null, name?: any | null, display_name?: any | null, latest_event?: any | null, user_ids?: any | null, sender?: any | null, created_at?: any | null, resource?: any | null, unread_counts: Array<{ __typename?: 'unread_counts', space_id?: any | null, unread_count?: any | null }> };

export type ChatListQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatListQuery = { __typename?: 'query_root', chat_list: Array<{ __typename?: 'chat_list', cover_photo?: any | null, id?: any | null, name?: any | null, display_name?: any | null, latest_event?: any | null, user_ids?: any | null, sender?: any | null, created_at?: any | null, resource?: any | null, unread_counts: Array<{ __typename?: 'unread_counts', space_id?: any | null, unread_count?: any | null }> }> };

export type ChatListSubscritionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ChatListSubscritionSubscription = { __typename?: 'subscription_root', chat_list: Array<{ __typename?: 'chat_list', cover_photo?: any | null, id?: any | null, name?: any | null, display_name?: any | null, latest_event?: any | null, user_ids?: any | null, sender?: any | null, created_at?: any | null, resource?: any | null, unread_counts: Array<{ __typename?: 'unread_counts', space_id?: any | null, unread_count?: any | null }> }> };

export type LogEventFragment = { __typename?: 'events', space_id: any, created_at?: any | null, user_id?: any | null, user_key?: any | null, sender_key: any, space_session: any, order: any, data: any, resource_key: any, type?: any | null, resource_id: any, localId?: any | null, collection_id?: any | null };

export type PushEventMutationVariables = Exact<{
  event: Events_Insert_Input;
}>;


export type PushEventMutation = { __typename?: 'mutation_root', insert_events_one?: { __typename?: 'events', space_id: any, created_at?: any | null, user_id?: any | null, user_key?: any | null, sender_key: any, space_session: any, order: any, data: any, resource_key: any, type?: any | null, resource_id: any, localId?: any | null, collection_id?: any | null } | null };

export type PushEventsMutationVariables = Exact<{
  events?: InputMaybe<Array<Events_Insert_Input> | Events_Insert_Input>;
}>;


export type PushEventsMutation = { __typename?: 'mutation_root', insert_events?: { __typename?: 'events_mutation_response', returning: Array<{ __typename?: 'events', space_id: any, created_at?: any | null, user_id?: any | null, user_key?: any | null, sender_key: any, space_session: any, order: any, data: any, resource_key: any, type?: any | null, resource_id: any, localId?: any | null, collection_id?: any | null }> } | null };

export type InvitationInfoFragment = { __typename?: 'invitations', id: any, created_at: any, updated_at: any, status?: any | null, space_id: any, user_id?: any | null, inviter_id?: any | null, external_metadata?: any | null };

export type InsertInvitationsMutationVariables = Exact<{
  invitations: Array<Invitations_Insert_Input> | Invitations_Insert_Input;
}>;


export type InsertInvitationsMutation = { __typename?: 'mutation_root', insert_invitations?: { __typename?: 'invitations_mutation_response', returning: Array<{ __typename?: 'invitations', id: any, created_at: any, updated_at: any, status?: any | null, space_id: any, user_id?: any | null, inviter_id?: any | null, external_metadata?: any | null }> } | null };

export type UpdateInvitationStatusMutationVariables = Exact<{
  id: Uuid;
  status: Scalars['String'];
}>;


export type UpdateInvitationStatusMutation = { __typename?: 'mutation_root', update_invitations?: { __typename?: 'invitations_mutation_response', returning: Array<{ __typename?: 'invitations', id: any, status?: any | null }> } | null };

export type DeleteInvitationMutationVariables = Exact<{
  id: Uuid;
}>;


export type DeleteInvitationMutation = { __typename?: 'mutation_root', delete_invitations_by_pk?: { __typename?: 'invitations', id: any } | null };

export type GetSpaceLatestEventTimestampsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpaceLatestEventTimestampsQuery = { __typename?: 'query_root', spaces: Array<{ __typename?: 'spaces', id: any, events_aggregate: { __typename?: 'events_aggregate', aggregate?: { __typename?: 'events_aggregate_fields', max?: { __typename?: 'events_max_fields', created_at?: any | null } | null } | null } }> };

export type SearchProfilesQueryVariables = Exact<{
  query: Scalars['String'];
}>;


export type SearchProfilesQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profiles', id: any, name?: any | null }> };

export type UpsertReadReceiptMutationVariables = Exact<{
  receipt: Read_Receipts_Insert_Input;
}>;


export type UpsertReadReceiptMutation = { __typename?: 'mutation_root', insert_read_receipts_one?: { __typename?: 'read_receipts', user_id: any, space_id: any, timestamp: any } | null };

export type ResourceCollectionLinkFragment = { __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any };

export type ResourceCollectionPermissionFragment = { __typename?: 'collection_permissions', collection_id: any, space_id: any };

export type ResourceCollectionInfoFragment = { __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> };

export type ResourceCollectionsQueryVariables = Exact<{
  where?: InputMaybe<Resource_Collections_Bool_Exp>;
}>;


export type ResourceCollectionsQuery = { __typename?: 'query_root', resource_collections: Array<{ __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> }> };

export type ResourceCollectionPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourceCollectionPermissionsQuery = { __typename?: 'query_root', collection_permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }> };

export type ResourceCollectionsSubscriptionSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourceCollectionsSubscriptionSubscription = { __typename?: 'subscription_root', resource_collections: Array<{ __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> }> };

export type CreateCollectionMutationVariables = Exact<{
  space_id?: InputMaybe<Uuid>;
  name: Scalars['String'];
}>;


export type CreateCollectionMutation = { __typename?: 'mutation_root', insert_resource_collections?: { __typename?: 'resource_collections_mutation_response', returning: Array<{ __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> }> } | null };

export type CreateCollectionWithDevIdMutationVariables = Exact<{
  space_id?: InputMaybe<Uuid>;
  name: Scalars['String'];
  dev_id: Scalars['String'];
}>;


export type CreateCollectionWithDevIdMutation = { __typename?: 'mutation_root', insert_resource_collections?: { __typename?: 'resource_collections_mutation_response', returning: Array<{ __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> }> } | null };

export type GetResourceCollectionByIdQueryVariables = Exact<{
  id: Uuid;
}>;


export type GetResourceCollectionByIdQuery = { __typename?: 'query_root', resource_collections_by_pk?: { __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> } | null };

export type GetResourceCollectionByDevIdQueryVariables = Exact<{
  dev_id: Scalars['String'];
}>;


export type GetResourceCollectionByDevIdQuery = { __typename?: 'query_root', resource_collections_by_dev_id?: { __typename?: 'resource_collections', id: any, dev_id: any, name: any, permissions: Array<{ __typename?: 'collection_permissions', collection_id: any, space_id: any }>, resources: Array<{ __typename?: 'resource_collection_links', collection_id: any, resource_id: any, resource_key: any }> } | null };

export type AddCollectionPermissionsMutationVariables = Exact<{
  permissions?: InputMaybe<Array<Collection_Permissions_Insert_Input> | Collection_Permissions_Insert_Input>;
}>;


export type AddCollectionPermissionsMutation = { __typename?: 'mutation_root', insert_collection_permissions?: { __typename?: 'collection_permissions_mutation_response', affected_rows: any } | null };

export type DeleteCollectionPermissionsMutationVariables = Exact<{
  collection_id: Uuid;
  space_ids: Array<Uuid> | Uuid;
}>;


export type DeleteCollectionPermissionsMutation = { __typename?: 'mutation_root', delete_collection_permissions?: { __typename?: 'collection_permissions_mutation_response', affected_rows: any } | null };

export type BulkCollectionPermissionMutationMutationVariables = Exact<{
  collection_id: Uuid;
  additions?: InputMaybe<Array<Collection_Permissions_Insert_Input> | Collection_Permissions_Insert_Input>;
  removals?: InputMaybe<Array<Uuid> | Uuid>;
}>;


export type BulkCollectionPermissionMutationMutation = { __typename?: 'mutation_root', insert_collection_permissions?: { __typename?: 'collection_permissions_mutation_response', affected_rows: any } | null, delete_collection_permissions?: { __typename?: 'collection_permissions_mutation_response', affected_rows: any } | null };

export type LocalResourceFragment = { __typename?: 'resources', local_id?: any | null, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any };

export type ResourcePermissionFragment = { __typename?: 'resource_permissions', resource_id: any, resource_key: any, space_id: any, created_at: any };

export type ResourcePermissionResourceFragment = { __typename?: 'resource_permissions', resource?: { __typename?: 'resources', local_id?: any | null, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any } | null };

export type GetResourcePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourcePermissionsQuery = { __typename?: 'query_root', resource_permissions: Array<{ __typename?: 'resource_permissions', resource_id: any, resource_key: any, space_id: any, created_at: any }> };

export type ResourcePermissionsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type ResourcePermissionsSubscription = { __typename?: 'subscription_root', resource_permissions: Array<{ __typename?: 'resource_permissions', resource_id: any, resource_key: any, space_id: any, created_at: any }> };

export type AddPermissionsMutationVariables = Exact<{
  permissions: Array<Resource_Permissions_Insert_Input> | Resource_Permissions_Insert_Input;
}>;


export type AddPermissionsMutation = { __typename?: 'mutation_root', insert_resource_permissions?: { __typename?: 'resource_permissions_mutation_response', affected_rows: any } | null };

export type ResourceFragment = { __typename?: 'resources', id: any, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any, space_id?: any | null, resource_permissions: Array<{ __typename?: 'resource_permissions', created_at: any, resource_id: any, resource_key: any, space_id: any }> };

export type CustomResourcesQueryVariables = Exact<{
  args?: InputMaybe<Resources_Query_V2_Args>;
  where?: InputMaybe<Resources_Bool_Exp>;
  order_by?: InputMaybe<Array<InputMaybe<Resources_Order_By>> | InputMaybe<Resources_Order_By>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CustomResourcesQuery = { __typename?: 'query_root', resources: Array<{ __typename?: 'resources', id: any, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any, space_id?: any | null, resource_permissions: Array<{ __typename?: 'resource_permissions', created_at: any, resource_id: any, resource_key: any, space_id: any }> }> };

export type CustomResourcesSubscriptionSubscriptionVariables = Exact<{
  args?: InputMaybe<Resources_Query_V2_Args>;
  where?: InputMaybe<Resources_Bool_Exp>;
  order_by?: InputMaybe<Array<InputMaybe<Resources_Order_By>> | InputMaybe<Resources_Order_By>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type CustomResourcesSubscriptionSubscription = { __typename?: 'subscription_root', resources: Array<{ __typename?: 'resources', id: any, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any, space_id?: any | null, resource_permissions: Array<{ __typename?: 'resource_permissions', created_at: any, resource_id: any, resource_key: any, space_id: any }> }> };

export type SimpleResourcesQueryVariables = Exact<{
  collectionKey: Scalars['String'];
  spaceId: Uuid;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
}>;


export type SimpleResourcesQuery = { __typename?: 'query_root', resources: Array<{ __typename?: 'resources', id: any, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any, space_id?: any | null, resource_permissions: Array<{ __typename?: 'resource_permissions', created_at: any, resource_id: any, resource_key: any, space_id: any }> }> };

export type GetResourceByIdQueryVariables = Exact<{
  collection_key: Scalars['String'];
  id: Scalars['String'];
}>;


export type GetResourceByIdQuery = { __typename?: 'query_root', resources_by_pk?: { __typename?: 'resources', id: any, data?: any | null, updated_at: any, created_at: any, collection_key: any, session_num: any, space_id?: any | null, resource_permissions: Array<{ __typename?: 'resource_permissions', created_at: any, resource_id: any, resource_key: any, space_id: any }> } | null };

export type AddSpaceAppMutationVariables = Exact<{
  app_name: Scalars['String'];
  fractional_index?: InputMaybe<Float8>;
  space_id: Uuid;
}>;


export type AddSpaceAppMutation = { __typename?: 'mutation_root', insert_space_apps_one?: { __typename?: 'space_apps', app_name: any } | null };

export type RemoveSpaceAppMutationVariables = Exact<{
  app_name: Scalars['String'];
  space_id: Uuid;
}>;


export type RemoveSpaceAppMutation = { __typename?: 'mutation_root', delete_space_apps_by_pk?: { __typename?: 'space_apps', app_name: any, space_id: any } | null };

export type SpaceMembersInfoFragment = { __typename?: 'space_members', id: any, user_id?: any | null, space_id: any, role?: any | null, created_at: any, updated_at: any, mute_notifications: any, invitation?: { __typename?: 'invitations', id: any, created_at: any, updated_at: any, status?: any | null, space_id: any, user_id?: any | null, inviter_id?: any | null, external_metadata?: any | null } | null };

export type GetSpaceMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSpaceMembersQuery = { __typename?: 'query_root', space_members: Array<{ __typename?: 'space_members', id: any, user_id?: any | null, space_id: any, role?: any | null, created_at: any, updated_at: any, mute_notifications: any, invitation?: { __typename?: 'invitations', id: any, created_at: any, updated_at: any, status?: any | null, space_id: any, user_id?: any | null, inviter_id?: any | null, external_metadata?: any | null } | null }> };

export type GetSpaceMemberProfilesQueryVariables = Exact<{
  space_id?: InputMaybe<Uuid_Comparison_Exp>;
}>;


export type GetSpaceMemberProfilesQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profiles', id: any, name?: any | null, profile_image_path?: any | null }> };

export type AllSpaceMembersSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AllSpaceMembersSubscription = { __typename?: 'subscription_root', space_members: Array<{ __typename?: 'space_members', id: any, user_id?: any | null, space_id: any, role?: any | null, created_at: any, updated_at: any, mute_notifications: any, invitation?: { __typename?: 'invitations', id: any, created_at: any, updated_at: any, status?: any | null, space_id: any, user_id?: any | null, inviter_id?: any | null, external_metadata?: any | null } | null }> };

export type SetMemberNotificationMuteMutationVariables = Exact<{
  id: Uuid;
  mute: Scalars['Boolean'];
}>;


export type SetMemberNotificationMuteMutation = { __typename?: 'mutation_root', update_space_members_by_pk?: { __typename?: 'space_members', id: any, mute_notifications: any } | null };

export type DeleteSpaceMemberMutationVariables = Exact<{
  id?: InputMaybe<Uuid>;
}>;


export type DeleteSpaceMemberMutation = { __typename?: 'mutation_root', delete_space_members_by_pk?: { __typename?: 'space_members', id: any } | null };

export type DeleteSpaceMemberBySpaceAndUserMutationVariables = Exact<{
  space_id?: InputMaybe<Uuid>;
  user_id?: InputMaybe<Uuid>;
}>;


export type DeleteSpaceMemberBySpaceAndUserMutation = { __typename?: 'mutation_root', delete_space_members?: { __typename?: 'space_members_mutation_response', returning: Array<{ __typename?: 'space_members', id: any }> } | null };

export type SpaceInfoFragment = { __typename?: 'spaces', id: any, join_id?: any | null, type?: any | null, name?: any | null, display_name?: any | null, created_at: any, updated_at: any, deleted: any, current_user_is_member?: any | null, cover_photo?: any | null, private_space_owner_id?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app_name: any, app: { __typename?: 'apps', name: any, title: any } }> };

export type GetUserSpacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserSpacesQuery = { __typename?: 'query_root', spaces: Array<{ __typename?: 'spaces', id: any, join_id?: any | null, type?: any | null, name?: any | null, display_name?: any | null, created_at: any, updated_at: any, deleted: any, current_user_is_member?: any | null, cover_photo?: any | null, private_space_owner_id?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app_name: any, app: { __typename?: 'apps', name: any, title: any } }> }> };

export type GetGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGroupsQuery = { __typename?: 'query_root', spaces: Array<{ __typename?: 'spaces', id: any, join_id?: any | null, type?: any | null, name?: any | null, display_name?: any | null, created_at: any, updated_at: any, deleted: any, current_user_is_member?: any | null, cover_photo?: any | null, private_space_owner_id?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app_name: any, app: { __typename?: 'apps', name: any, title: any } }> }> };

export type AllUserSpacesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AllUserSpacesSubscription = { __typename?: 'subscription_root', spaces: Array<{ __typename?: 'spaces', id: any, join_id?: any | null, type?: any | null, name?: any | null, display_name?: any | null, created_at: any, updated_at: any, deleted: any, current_user_is_member?: any | null, cover_photo?: any | null, private_space_owner_id?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app_name: any, app: { __typename?: 'apps', name: any, title: any } }> }> };

export type GetMutualSpacesQueryVariables = Exact<{
  user_id?: InputMaybe<Uuid>;
}>;


export type GetMutualSpacesQuery = { __typename?: 'query_root', spaces: Array<{ __typename?: 'spaces', id: any, join_id?: any | null, type?: any | null, name?: any | null, display_name?: any | null, created_at: any, updated_at: any, deleted: any, current_user_is_member?: any | null, cover_photo?: any | null, private_space_owner_id?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app_name: any, app: { __typename?: 'apps', name: any, title: any } }> }> };

export type InsertSpaceMutationVariables = Exact<{
  space: Spaces_Insert_Input;
}>;


export type InsertSpaceMutation = { __typename?: 'mutation_root', insert_spaces_one?: { __typename?: 'spaces', id: any, name?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app: { __typename?: 'apps', name: any, title: any } }>, invitations: Array<{ __typename?: 'invitations', user_id?: any | null, status?: any | null, inviter_id?: any | null, external_metadata?: any | null }> } | null };

export type InsertSpacesMutationVariables = Exact<{
  spaces?: InputMaybe<Array<Spaces_Insert_Input> | Spaces_Insert_Input>;
}>;


export type InsertSpacesMutation = { __typename?: 'mutation_root', insert_spaces?: { __typename?: 'spaces_mutation_response', returning: Array<{ __typename?: 'spaces', id: any, name?: any | null, apps: Array<{ __typename?: 'space_apps', fractional_index: any, app: { __typename?: 'apps', name: any, title: any } }>, invitations: Array<{ __typename?: 'invitations', user_id?: any | null, status?: any | null, inviter_id?: any | null, external_metadata?: any | null }> }> } | null };

export type InsertStaticSpaceMutationVariables = Exact<{
  id: Uuid;
  members: Array<Space_Members_Insert_Input> | Space_Members_Insert_Input;
}>;


export type InsertStaticSpaceMutation = { __typename?: 'mutation_root', insert_spaces_one?: { __typename?: 'spaces', id: any } | null };

export type DeleteSpaceMutationVariables = Exact<{
  space_id: Uuid;
}>;


export type DeleteSpaceMutation = { __typename?: 'mutation_root', update_spaces?: { __typename?: 'spaces_mutation_response', returning: Array<{ __typename?: 'spaces', id: any, deleted: any }> } | null };

export type RenameSpaceMutationVariables = Exact<{
  space_id: Uuid;
  new_name?: InputMaybe<Scalars['String']>;
}>;


export type RenameSpaceMutation = { __typename?: 'mutation_root', update_spaces?: { __typename?: 'spaces_mutation_response', returning: Array<{ __typename?: 'spaces', id: any }> } | null };

export type SetSpaceCoverPhotoMutationVariables = Exact<{
  space_id: Uuid;
  cover_photo?: InputMaybe<Jsonb>;
}>;


export type SetSpaceCoverPhotoMutation = { __typename?: 'mutation_root', update_spaces?: { __typename?: 'spaces_mutation_response', returning: Array<{ __typename?: 'spaces', id: any }> } | null };

export type ProfileInfoFragment = { __typename?: 'profiles', name?: any | null, id: any, is_invited?: any | null, notification_badge?: { __typename?: 'notification_badges', value?: any | null } | null };

export type GetUserProfileQueryVariables = Exact<{
  id: Uuid;
}>;


export type GetUserProfileQuery = { __typename?: 'query_root', profiles_by_pk?: { __typename?: 'profiles', name?: any | null, id: any, is_invited?: any | null, notification_badge?: { __typename?: 'notification_badges', value?: any | null } | null } | null };

export type CompleteProfileMutationVariables = Exact<{
  id?: InputMaybe<Uuid>;
  name?: InputMaybe<Scalars['String']>;
  profile_image_path?: InputMaybe<Scalars['String']>;
}>;


export type CompleteProfileMutation = { __typename?: 'mutation_root', update_profiles_by_pk?: { __typename?: 'profiles', id: any } | null };

export type UpdateProfileImageMutationVariables = Exact<{
  id?: InputMaybe<Uuid>;
  image_path?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfileImageMutation = { __typename?: 'mutation_root', update_profiles_by_pk?: { __typename?: 'profiles', id: any } | null };

export type UpdateProfileNameMutationVariables = Exact<{
  id?: InputMaybe<Uuid>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type UpdateProfileNameMutation = { __typename?: 'mutation_root', update_profiles_by_pk?: { __typename?: 'profiles', id: any } | null };

export type DeleteProfileMutationVariables = Exact<{
  id: Uuid;
}>;


export type DeleteProfileMutation = { __typename?: 'mutation_root', delete_profiles_by_pk?: { __typename?: 'profiles', id: any } | null };

export type UserProfileSubscriptionVariables = Exact<{
  id?: InputMaybe<Uuid>;
}>;


export type UserProfileSubscription = { __typename?: 'subscription_root', profiles_by_pk?: { __typename?: 'profiles', name?: any | null, id: any, is_invited?: any | null, notification_badge?: { __typename?: 'notification_badges', value?: any | null } | null } | null };

export type ProfilesInfoFragment = { __typename?: 'profiles', id: any, name?: any | null, updated_at: any, profile_image_path?: any | null, personal_space?: { __typename?: 'spaces', id: any } | null };

export type GetConnectedProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectedProfilesQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profiles', id: any, name?: any | null, updated_at: any, profile_image_path?: any | null, personal_space?: { __typename?: 'spaces', id: any } | null }> };

export type AllConnectedProfilesSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type AllConnectedProfilesSubscription = { __typename?: 'subscription_root', profiles: Array<{ __typename?: 'profiles', id: any, name?: any | null, updated_at: any, profile_image_path?: any | null, personal_space?: { __typename?: 'spaces', id: any } | null }> };

export const UnreadCountInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnreadCountInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"unread_counts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"unread_count"}}]}}]} as unknown as DocumentNode<UnreadCountInfoFragment, unknown>;
export const ChatListItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ChatListItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"chat_list"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cover_photo"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"latest_event"}},{"kind":"Field","alias":{"kind":"Name","value":"resource"},"name":{"kind":"Name","value":"latest_resource"}},{"kind":"Field","name":{"kind":"Name","value":"user_ids"}},{"kind":"Field","name":{"kind":"Name","value":"sender"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"unread_counts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnreadCountInfo"}}]}}]}},...UnreadCountInfoFragmentDoc.definitions]} as unknown as DocumentNode<ChatListItemFragment, unknown>;
export const LogEventFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LogEvent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"events"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_key"}},{"kind":"Field","name":{"kind":"Name","value":"sender_key"}},{"kind":"Field","name":{"kind":"Name","value":"space_session"}},{"kind":"Field","name":{"kind":"Name","value":"order"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"resource_key"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"resource_id"}},{"kind":"Field","name":{"kind":"Name","value":"localId"}},{"kind":"Field","name":{"kind":"Name","value":"collection_id"}}]}}]} as unknown as DocumentNode<LogEventFragment, unknown>;
export const ResourceCollectionPermissionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCollectionPermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"collection_permissions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}}]}}]} as unknown as DocumentNode<ResourceCollectionPermissionFragment, unknown>;
export const ResourceCollectionLinkFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCollectionLink"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resource_collection_links"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_key"}}]}}]} as unknown as DocumentNode<ResourceCollectionLinkFragment, unknown>;
export const ResourceCollectionInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceCollectionInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resource_collections"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dev_id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionPermission"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionLink"}}]}}]}},...ResourceCollectionPermissionFragmentDoc.definitions,...ResourceCollectionLinkFragmentDoc.definitions]} as unknown as DocumentNode<ResourceCollectionInfoFragment, unknown>;
export const ResourcePermissionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourcePermission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resource_permissions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_key"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]} as unknown as DocumentNode<ResourcePermissionFragment, unknown>;
export const LocalResourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocalResource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"local_id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"collection_key"}},{"kind":"Field","name":{"kind":"Name","value":"session_num"}}]}}]} as unknown as DocumentNode<LocalResourceFragment, unknown>;
export const ResourcePermissionResourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourcePermissionResource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resource_permissions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocalResource"}}]}}]}},...LocalResourceFragmentDoc.definitions]} as unknown as DocumentNode<ResourcePermissionResourceFragment, unknown>;
export const ResourceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Resource"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"resources"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"collection_key"}},{"kind":"Field","name":{"kind":"Name","value":"session_num"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"resource_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_key"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}}]}}]}}]} as unknown as DocumentNode<ResourceFragment, unknown>;
export const InvitationInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InvitationInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"invitations"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"inviter_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_metadata"}}]}}]} as unknown as DocumentNode<InvitationInfoFragment, unknown>;
export const SpaceMembersInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpaceMembersInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"space_members"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"mute_notifications"}},{"kind":"Field","name":{"kind":"Name","value":"invitation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvitationInfo"}}]}}]}},...InvitationInfoFragmentDoc.definitions]} as unknown as DocumentNode<SpaceMembersInfoFragment, unknown>;
export const SpaceInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SpaceInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"spaces"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"join_id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"display_name"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}},{"kind":"Field","name":{"kind":"Name","value":"current_user_is_member"}},{"kind":"Field","name":{"kind":"Name","value":"cover_photo"}},{"kind":"Field","name":{"kind":"Name","value":"private_space_owner_id"}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fractional_index"}},{"kind":"Field","name":{"kind":"Name","value":"app_name"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<SpaceInfoFragment, unknown>;
export const ProfileInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profiles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_invited"}},{"kind":"Field","name":{"kind":"Name","value":"notification_badge"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ProfileInfoFragment, unknown>;
export const ProfilesInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfilesInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profiles"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"updated_at"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_path"}},{"kind":"Field","name":{"kind":"Name","value":"personal_space"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProfilesInfoFragment, unknown>;
export const MakeAccessRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MakeAccessRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requester_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipient_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resource_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_access_requests_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"requester_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requester_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"recipient_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipient_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"resource_type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resource_type"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"metadata"},"value":{"kind":"Variable","name":{"kind":"Name","value":"metadata"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<MakeAccessRequestMutation, MakeAccessRequestMutationVariables>;
export const GetAccessRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resource_type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"access_requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resource_type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resource_type"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"key"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"recipient_id"}},{"kind":"Field","name":{"kind":"Name","value":"requester_id"}},{"kind":"Field","name":{"kind":"Name","value":"resource_type"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}}]}}]}}]} as unknown as DocumentNode<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>;
export const ChatListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ChatList"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChatListItem"}}]}}]}},...ChatListItemFragmentDoc.definitions]} as unknown as DocumentNode<ChatListQuery, ChatListQueryVariables>;
export const ChatListSubscritionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ChatListSubscrition"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"chat_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ChatListItem"}}]}}]}},...ChatListItemFragmentDoc.definitions]} as unknown as DocumentNode<ChatListSubscritionSubscription, ChatListSubscritionSubscriptionVariables>;
export const PushEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pushEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"event"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"events_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_events_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"event"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEvent"}}]}}]}},...LogEventFragmentDoc.definitions]} as unknown as DocumentNode<PushEventMutation, PushEventMutationVariables>;
export const PushEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"pushEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"events"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"events_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_events"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"events"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LogEvent"}}]}}]}}]}},...LogEventFragmentDoc.definitions]} as unknown as DocumentNode<PushEventsMutation, PushEventsMutationVariables>;
export const InsertInvitationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertInvitations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"invitations"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"invitations_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_invitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"invitations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InvitationInfo"}}]}}]}}]}},...InvitationInfoFragmentDoc.definitions]} as unknown as DocumentNode<InsertInvitationsMutation, InsertInvitationsMutationVariables>;
export const UpdateInvitationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInvitationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_invitations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateInvitationStatusMutation, UpdateInvitationStatusMutationVariables>;
export const DeleteInvitationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteInvitation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_invitations_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteInvitationMutation, DeleteInvitationMutationVariables>;
export const GetSpaceLatestEventTimestampsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpaceLatestEventTimestamps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"events_aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"max"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetSpaceLatestEventTimestampsQuery, GetSpaceLatestEventTimestampsQueryVariables>;
export const SearchProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_ilike"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchProfilesQuery, SearchProfilesQueryVariables>;
export const UpsertReadReceiptDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertReadReceipt"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"receipt"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"read_receipts_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_read_receipts_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"receipt"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"last_seen_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"timestamp"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}}]}}]}}]} as unknown as DocumentNode<UpsertReadReceiptMutation, UpsertReadReceiptMutationVariables>;
export const ResourceCollectionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourceCollections"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"resource_collections_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<ResourceCollectionsQuery, ResourceCollectionsQueryVariables>;
export const ResourceCollectionPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourceCollectionPermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"collection_permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionPermission"}}]}}]}},...ResourceCollectionPermissionFragmentDoc.definitions]} as unknown as DocumentNode<ResourceCollectionPermissionsQuery, ResourceCollectionPermissionsQueryVariables>;
export const ResourceCollectionsSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ResourceCollectionsSubscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_collections"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<ResourceCollectionsSubscriptionSubscription, ResourceCollectionsSubscriptionSubscriptionVariables>;
export const CreateCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_resource_collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"resource_collections_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<CreateCollectionMutation, CreateCollectionMutationVariables>;
export const CreateCollectionWithDevIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCollectionWithDevId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dev_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_resource_collections"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"dev_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dev_id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"collection_permissions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"resource_collections_dev_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<CreateCollectionWithDevIdMutation, CreateCollectionWithDevIdMutationVariables>;
export const GetResourceCollectionByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceCollectionById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_collections_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetResourceCollectionByIdQuery, GetResourceCollectionByIdQueryVariables>;
export const GetResourceCollectionByDevIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceCollectionByDevId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"dev_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_collections_by_dev_id"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_dev_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"dev_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceCollectionInfo"}}]}}]}},...ResourceCollectionInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetResourceCollectionByDevIdQuery, GetResourceCollectionByDevIdQueryVariables>;
export const AddCollectionPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddCollectionPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"collection_permissions_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_collection_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"collection_permissions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AddCollectionPermissionsMutation, AddCollectionPermissionsMutationVariables>;
export const DeleteCollectionPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteCollectionPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_ids"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_collection_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_ids"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<DeleteCollectionPermissionsMutation, DeleteCollectionPermissionsMutationVariables>;
export const BulkCollectionPermissionMutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BulkCollectionPermissionMutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"additions"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"collection_permissions_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"removals"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},"defaultValue":{"kind":"ListValue","values":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_collection_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"additions"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"collection_permissions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}},{"kind":"Field","name":{"kind":"Name","value":"delete_collection_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_in"},"value":{"kind":"Variable","name":{"kind":"Name","value":"removals"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<BulkCollectionPermissionMutationMutation, BulkCollectionPermissionMutationMutationVariables>;
export const GetResourcePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourcePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourcePermission"}}]}}]}},...ResourcePermissionFragmentDoc.definitions]} as unknown as DocumentNode<GetResourcePermissionsQuery, GetResourcePermissionsQueryVariables>;
export const ResourcePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ResourcePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource_permissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourcePermission"}}]}}]}},...ResourcePermissionFragmentDoc.definitions]} as unknown as DocumentNode<ResourcePermissionsSubscription, ResourcePermissionsSubscriptionVariables>;
export const AddPermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPermissions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resource_permissions_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_resource_permissions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"permissions"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"resource_permissions_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"affected_rows"}}]}}]}}]} as unknown as DocumentNode<AddPermissionsMutation, AddPermissionsMutationVariables>;
export const CustomResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CustomResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_query_v2_args"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_order_by"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"resources"},"name":{"kind":"Name","value":"resources_query_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Resource"}}]}}]}},...ResourceFragmentDoc.definitions]} as unknown as DocumentNode<CustomResourcesQuery, CustomResourcesQueryVariables>;
export const CustomResourcesSubscriptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"CustomResourcesSubscription"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"args"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_query_v2_args"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_bool_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"resources_order_by"}}},"defaultValue":{"kind":"ObjectValue","fields":[]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"resources"},"name":{"kind":"Name","value":"resources_query_v2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"args"},"value":{"kind":"Variable","name":{"kind":"Name","value":"args"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"Variable","name":{"kind":"Name","value":"order_by"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Resource"}}]}}]}},...ResourceFragmentDoc.definitions]} as unknown as DocumentNode<CustomResourcesSubscriptionSubscription, CustomResourcesSubscriptionSubscriptionVariables>;
export const SimpleResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SimpleResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collectionKey"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection_key"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collectionKey"}}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_or"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"resource_permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collections"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"collection"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"permissions"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaceId"}}}]}}]}}]}}]}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":false}}]}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"order_by"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Resource"}}]}}]}},...ResourceFragmentDoc.definitions]} as unknown as DocumentNode<SimpleResourcesQuery, SimpleResourcesQueryVariables>;
export const GetResourceByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"collection_key"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"collection_key"},"value":{"kind":"Variable","name":{"kind":"Name","value":"collection_key"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Resource"}}]}}]}},...ResourceFragmentDoc.definitions]} as unknown as DocumentNode<GetResourceByIdQuery, GetResourceByIdQueryVariables>;
export const AddSpaceAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSpaceApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fractional_index"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"float8"}},"defaultValue":{"kind":"FloatValue","value":"0.5"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_space_apps_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app_name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"fractional_index"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fractional_index"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app_name"}}]}}]}}]} as unknown as DocumentNode<AddSpaceAppMutation, AddSpaceAppMutationVariables>;
export const RemoveSpaceAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSpaceApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"app_name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_space_apps_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"app_name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"app_name"}}},{"kind":"Argument","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"app_name"}},{"kind":"Field","name":{"kind":"Name","value":"space_id"}}]}}]}}]} as unknown as DocumentNode<RemoveSpaceAppMutation, RemoveSpaceAppMutationVariables>;
export const GetSpaceMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpaceMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space_members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceMembersInfo"}}]}}]}},...SpaceMembersInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetSpaceMembersQuery, GetSpaceMembersQueryVariables>;
export const GetSpaceMemberProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSpaceMemberProfiles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid_comparison_exp"}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"profile_image_path"}}]}}]}}]} as unknown as DocumentNode<GetSpaceMemberProfilesQuery, GetSpaceMemberProfilesQueryVariables>;
export const AllSpaceMembersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllSpaceMembers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"space_members"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceMembersInfo"}}]}}]}},...SpaceMembersInfoFragmentDoc.definitions]} as unknown as DocumentNode<AllSpaceMembersSubscription, AllSpaceMembersSubscriptionVariables>;
export const SetMemberNotificationMuteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetMemberNotificationMute"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"mute"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_space_members_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"mute_notifications"},"value":{"kind":"Variable","name":{"kind":"Name","value":"mute"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"mute_notifications"}}]}}]}}]} as unknown as DocumentNode<SetMemberNotificationMuteMutation, SetMemberNotificationMuteMutationVariables>;
export const DeleteSpaceMemberDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpaceMember"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_space_members_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteSpaceMemberMutation, DeleteSpaceMemberMutationVariables>;
export const DeleteSpaceMemberBySpaceAndUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpaceMemberBySpaceAndUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_space_members"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"space_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSpaceMemberBySpaceAndUserMutation, DeleteSpaceMemberBySpaceAndUserMutationVariables>;
export const GetUserSpacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceInfo"}}]}}]}},...SpaceInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetUserSpacesQuery, GetUserSpacesQueryVariables>;
export const GetGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetGroups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_and"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_is_null"},"value":{"kind":"BooleanValue","value":true}}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_neq"},"value":{"kind":"StringValue","value":"","block":false}}]}}]}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceInfo"}}]}}]}},...SpaceInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetGroupsQuery, GetGroupsQueryVariables>;
export const AllUserSpacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllUserSpaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaces"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceInfo"}}]}}]}},...SpaceInfoFragmentDoc.definitions]} as unknown as DocumentNode<AllUserSpacesSubscription, AllUserSpacesSubscriptionVariables>;
export const GetMutualSpacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetMutualSpaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"user_id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"user_id"}}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"BooleanValue","value":false}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SpaceInfo"}}]}}]}},...SpaceInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetMutualSpacesQuery, GetMutualSpacesQueryVariables>;
export const InsertSpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spaces_insert_input"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spaces_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"spaces_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fractional_index"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"inviter_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_metadata"}}]}}]}}]}}]} as unknown as DocumentNode<InsertSpaceMutation, InsertSpaceMutationVariables>;
export const InsertSpacesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertSpaces"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"spaces"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"spaces_insert_input"}}}},"defaultValue":{"kind":"ObjectValue","fields":[]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"objects"},"value":{"kind":"Variable","name":{"kind":"Name","value":"spaces"}}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"spaces_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"name"},{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"apps"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fractional_index"}},{"kind":"Field","name":{"kind":"Name","value":"app"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"invitations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user_id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"inviter_id"}},{"kind":"Field","name":{"kind":"Name","value":"external_metadata"}}]}}]}}]}}]}}]} as unknown as DocumentNode<InsertSpacesMutation, InsertSpacesMutationVariables>;
export const InsertStaticSpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"InsertStaticSpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"members"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"space_members_insert_input"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"insert_spaces_one"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"object"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"members"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"members"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"space_members_space_id_user_id_key"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"BooleanValue","value":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"type"},"value":{"kind":"StringValue","value":"STATIC","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"apps"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"data"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"app_name"},"value":{"kind":"StringValue","value":"Chat","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"fractional_index"},"value":{"kind":"StringValue","value":"0.5","block":false}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"space_apps_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[]}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"on_conflict"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"constraint"},"value":{"kind":"EnumValue","value":"spaces_pkey"}},{"kind":"ObjectField","name":{"kind":"Name","value":"update_columns"},"value":{"kind":"ListValue","values":[{"kind":"EnumValue","value":"deleted"}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<InsertStaticSpaceMutation, InsertStaticSpaceMutationVariables>;
export const DeleteSpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteSpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"deleted"},"value":{"kind":"BooleanValue","value":true}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"deleted"}}]}}]}}]}}]} as unknown as DocumentNode<DeleteSpaceMutation, DeleteSpaceMutationVariables>;
export const RenameSpaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RenameSpace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"new_name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"new_name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<RenameSpaceMutation, RenameSpaceMutationVariables>;
export const SetSpaceCoverPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SetSpaceCoverPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cover_photo"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"jsonb"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_spaces"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"_eq"},"value":{"kind":"Variable","name":{"kind":"Name","value":"space_id"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"cover_photo"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cover_photo"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"returning"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SetSpaceCoverPhotoMutation, SetSpaceCoverPhotoMutationVariables>;
export const GetUserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileInfo"}}]}}]}},...ProfileInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetUserProfileQuery, GetUserProfileQueryVariables>;
export const CompleteProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompleteProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"profile_image_path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"profile_image_path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"profile_image_path"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CompleteProfileMutation, CompleteProfileMutationVariables>;
export const UpdateProfileImageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileImage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"image_path"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"profile_image_path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"image_path"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileImageMutation, UpdateProfileImageMutationVariables>;
export const UpdateProfileNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfileName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"update_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_columns"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"_set"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateProfileNameMutation, UpdateProfileNameMutationVariables>;
export const DeleteProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteProfileMutation, DeleteProfileMutationVariables>;
export const UserProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"UserProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"uuid"}},"defaultValue":{"kind":"StringValue","value":"","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles_by_pk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileInfo"}}]}}]}},...ProfileInfoFragmentDoc.definitions]} as unknown as DocumentNode<UserProfileSubscription, UserProfileSubscriptionVariables>;
export const GetConnectedProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConnectedProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilesInfo"}}]}}]}},...ProfilesInfoFragmentDoc.definitions]} as unknown as DocumentNode<GetConnectedProfilesQuery, GetConnectedProfilesQueryVariables>;
export const AllConnectedProfilesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"AllConnectedProfiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profiles"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfilesInfo"}}]}}]}},...ProfilesInfoFragmentDoc.definitions]} as unknown as DocumentNode<AllConnectedProfilesSubscription, AllConnectedProfilesSubscriptionVariables>;